window.UnisourceQuoteModal = window.UnisourceQuoteModal || {};

(function () {
  "use strict";

  window.UNISOURCE_QUOTE_MODAL_VERSION = "v52-admin-field-labels-webstore";

  var API_URL =
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/forms/submit";

  var FORM_CONFIG_URL =
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/forms/config/request-quote";

  var state = {
    initialized: false,
    submitting: false,
    triggerContext: {},
    currentRfqType: "general",
    formConfig: null,
    formConfigLoaded: false
  };

  var DEFAULT_PRINT_LOCATIONS = [
    "Full Front",
    "Left Chest",
    "Right Chest",
    "Full Back",
    "Left Sleeve",
    "Right Sleeve",
    "Other"
  ];

  var PROMOTIONAL_IMPRINT_LOCATIONS = {
    "Lanyards": ["Front side", "Back side", "Repeating print", "Clip / attachment area", "Not Sure"],
    "Pens": ["Barrel", "Clip", "Cap", "One Side", "Two Sides", "Not Sure"],
    "Mugs": ["Front", "Back", "Both Sides", "Wraparound", "Inside Rim", "Bottom", "Not Sure"],
    "Water Bottles / Tumblers": ["Front", "Back", "Both Sides", "Wraparound", "Lid", "Not Sure"],
    "Tote Bags": ["Front", "Back", "Inside Label", "Not Sure"],
    "Drawstring Bags": ["Front", "Back", "Not Sure"],
    "Notebooks / Journals": ["Front Cover", "Back Cover", "Inside Page", "Not Sure"],
    "Keychains": ["Front", "Back", "Both Sides", "Not Sure"],
    "Stickers / Decals": ["Single Side", "Sheet Layout", "Not Sure"],
    "Giveaways / Event Items": ["Front", "Back", "One Side", "Multiple Locations", "Not Sure"],
    "Other": ["Front", "Back", "One Side", "Both Sides", "Multiple Locations", "Not Sure"],
    "Not Sure": ["Front", "Back", "One Side", "Both Sides", "Multiple Locations", "Not Sure"]
  };

  var DEFAULT_DECORATION_METHODS = [
    "Screen printing",
    "Embroidery",
    "Heat transfer",
    "Direct-to-garment",
    "Other"
  ];

  var PROMOTIONAL_DECORATION_METHODS = {
    "Lanyards": [
      "Screen printing",
      "Dye sublimation / full color",
      "Woven",
      "Heat transfer",
      "Not Sure"
    ],
    "Pens": [
      "Pad print",
      "Laser engraving",
      "Full color print",
      "Screen printing",
      "Not Sure"
    ],
    "Mugs": [
      "Screen printing",
      "Full color print",
      "Sublimation",
      "Laser engraving",
      "Not Sure"
    ],
    "Water Bottles / Tumblers": [
      "Laser engraving",
      "Screen printing",
      "Full color print",
      "UV print",
      "Wraparound print",
      "Not Sure"
    ],
    "Tote Bags": [
      "Screen printing",
      "Heat transfer",
      "Embroidery",
      "Full color print",
      "Not Sure"
    ],
    "Drawstring Bags": [
      "Screen printing",
      "Heat transfer",
      "Full color print",
      "Not Sure"
    ],
    "Notebooks / Journals": [
      "Full color print",
      "Screen printing",
      "Deboss / emboss",
      "Foil stamp",
      "Not Sure"
    ],
    "Keychains": [
      "Laser engraving",
      "Full color print",
      "Pad print",
      "Not Sure"
    ],
    "Stickers / Decals": [
      "Full color print",
      "Die cut",
      "Sheet layout",
      "Not Sure"
    ],
    "Giveaways / Event Items": [
      "Pad print",
      "Screen printing",
      "Full color print",
      "Laser engraving",
      "Not Sure"
    ],
    "Other": [
      "Pad print",
      "Screen printing",
      "Full color print",
      "Laser engraving",
      "Embroidery",
      "Not Sure"
    ],
    "Not Sure": [
      "Pad print",
      "Screen printing",
      "Full color print",
      "Laser engraving",
      "Embroidery",
      "Not Sure"
    ]
  };


  var STOLE_TASSEL_DECORATION_METHODS = [
    "Embroidery",
    "Screen printing",
    "Full color print",
    "Patch",
    "Metallic / foil",
    "Not Sure"
  ];

  var STOLE_TASSEL_PLACEMENT_OPTIONS = [
    "Left panel",
    "Right panel",
    "Both panels",
    "Bottom ends",
    "Back side",
    "Tassel charm / tag",
    "Not Sure"
  ];

  var TASSEL_COLOR_OPTIONS = [
    "Black",
    "White",
    "Navy",
    "Royal Blue",
    "Columbia Blue",
    "Red",
    "Maroon",
    "Orange",
    "Gold",
    "Old Gold",
    "Kelly Green",
    "Forest Green",
    "Purple",
    "Silver",
    "Pink",
    "Other / Custom",
    "Not Sure"
  ];


  var SUBLIMATED_DECORATION_METHODS = [
    "Full sublimation",
    "Partial sublimation",
    "Screen printing",
    "Embroidery",
    "Heat transfer",
    "Not Sure"
  ];

  var SUBLIMATED_PLACEMENT_OPTIONS = [
    "Full uniform",
    "Front only",
    "Back only",
    "Sleeves",
    "Shorts",
    "Player names",
    "Player numbers",
    "Sponsor logos",
    "Not Sure"
  ];


  var PE_PRINT_LOCATION_OPTIONS = [
    "T-shirt Full Front",
    "T-shirt Left Chest",
    "T-shirt Full Back",
    "Sweatshirt Full Front",
    "Sweatshirt Left Chest",
    "Sweatshirt Full Back",
    "Shorts Left Leg",
    "Shorts Right Leg",
    "Sweatpants Left Leg",
    "Sweatpants Right Leg",
    "Other",
    "Not Sure"
  ];

  var PE_APPAREL_OPTIONS = [
    "T-shirt",
    "Shorts",
    "Sweatshirt",
    "Sweatpants"
  ];

  function buildModalHtml() {
    return `
      <style id="uqm-custom-webstore-layout">
        .uqm--custom-webstore .uqm__columns {
          align-items: start;
        }

        .uqm--custom-webstore .uqm__mode-section--webstore {
          margin-top: 0;
        }

        .uqm--custom-webstore .uqm__mode-section--webstore-left,
        .uqm--custom-webstore .uqm__mode-section--webstore-right {
          display: block;
        }

        .uqm--custom-webstore .uqm__mode-section--webstore .uqm__mode-banner {
          margin-bottom: 12px;
        }

        .uqm--custom-webstore .uqm__section--first {
          padding-bottom: 0;
        }

        @media (max-width: 900px) {
          .uqm--custom-webstore .uqm__columns {
            grid-template-columns: 1fr;
          }
        }
      </style>
      <div id="unisource-quote-modal" class="uqm" aria-hidden="true">
        <div class="uqm__backdrop" data-uqm-close></div>

        <div class="uqm__dialog" role="dialog" aria-modal="true" aria-labelledby="uqm-title">
          <button
            type="button"
            class="uqm__close"
            aria-label="Close Request a Quote form"
            data-uqm-close
          >×</button>

          <div class="uqm__header">
            <p class="uqm__eyebrow">Request a Quote</p>
            <h2 id="uqm-title">Tell us about your project</h2>
            <p>Product information is filled automatically when available.</p>
          </div>

          <div id="uqm-alert" class="uqm__alert" role="status" aria-live="polite" hidden></div>

          <form id="uqm-form" class="uqm__form" novalidate>
            <div class="uqm__columns">
              <!-- LEFT COLUMN -->
              <div class="uqm__column">
                <section class="uqm__section">
                  <h3>Contact information</h3>

                  <div class="uqm__grid">
                    <div class="uqm__field">
                      <label for="uqm-name">Name *</label>
                      <input id="uqm-name" name="name" type="text" maxlength="120" autocomplete="name" required>
                      <small data-uqm-error="name"></small>
                    </div>

                    <div class="uqm__field">
                      <label for="uqm-organization">School, organization, or company *</label>
                      <input id="uqm-organization" name="organization" type="text" maxlength="160" autocomplete="organization" required>
                      <small data-uqm-error="organization"></small>
                    </div>

                    <div class="uqm__field">
                      <label for="uqm-email">Email *</label>
                      <input id="uqm-email" name="email" type="email" maxlength="180" autocomplete="email" required>
                      <small data-uqm-error="email"></small>
                    </div>

                    <div class="uqm__field">
                      <label for="uqm-phone">Phone *</label>
                      <input id="uqm-phone" name="phone" type="tel" maxlength="60" autocomplete="tel" required>
                      <small data-uqm-error="phone"></small>
                    </div>

                    <fieldset class="uqm__field uqm__field--full uqm__contact-methods">
                      <legend>Preferred contact method</legend>
                      <div class="uqm__radio-row">
                        <label><input type="radio" name="preferredContactMethod" value="email" checked> <span>Email</span></label>
                        <label><input type="radio" name="preferredContactMethod" value="phone"> <span>Phone</span></label>
                        <label><input type="radio" name="preferredContactMethod" value="either"> <span>Either</span></label>
                      </div>
                    </fieldset>
                  </div>
                </section>

                <section class="uqm__section">
                  <h3 id="uqm-product-section-title">Product and quantity</h3>

                  <div id="uqm-product-summary" class="uqm__product-summary" hidden>
                    <img id="uqm-product-image" alt="" hidden>
                    <div>
                      <strong id="uqm-product-summary-name"></strong>
                      <span id="uqm-product-summary-meta"></span>
                    </div>
                  </div>

                  <div class="uqm__grid">
                    <div class="uqm__field uqm__field--full" data-uqm-product-name-field>
                      <label for="uqm-product-name" id="uqm-product-name-label">Product name</label>
                      <input id="uqm-product-name" name="productName" type="text" maxlength="300">
                    </div>

                    <div class="uqm__field uqm__field--full" data-uqm-controller-field="promotional" hidden>
                      <label for="uqm-promo-product-type">Promotional product type *</label>
                      <select id="uqm-promo-product-type" name="promotionalProductType">
                        <option value="">Select product type</option>
                        <option value="Lanyards">Lanyards</option>
                        <option value="Pens">Pens</option>
                        <option value="Mugs">Mugs</option>
                        <option value="Water Bottles / Tumblers">Water Bottles / Tumblers</option>
                        <option value="Tote Bags">Tote Bags</option>
                        <option value="Drawstring Bags">Drawstring Bags</option>
                        <option value="Notebooks / Journals">Notebooks / Journals</option>
                        <option value="Keychains">Keychains</option>
                        <option value="Stickers / Decals">Stickers / Decals</option>
                        <option value="Giveaways / Event Items">Giveaways / Event Items</option>
                        <option value="Other">Other</option>
                        <option value="Not Sure">Not Sure</option>
                      </select>
                      <small data-uqm-error="promotionalProductType"></small>
                    </div>

                    <div class="uqm__field uqm__field--full" data-uqm-controller-field="stole-tassel" hidden>
                      <label for="uqm-stole-type">Gown / stole / tassel request type *</label>
                      <select id="uqm-stole-type" name="stoleType">
                        <option value="">Select request type</option>
                        <option value="Stole Only">Stole Only</option>
                        <option value="Tassel Only">Tassel Only</option>
                        <option value="Gown Only">Gown Only</option>
                        <option value="Stole + Tassel Set">Stole + Tassel Set</option>
                        <option value="Cap + Gown Set">Cap + Gown Set</option>
                        <option value="Cap + Gown + Tassel Set">Cap + Gown + Tassel Set</option>
                        <option value="Full Graduation Set">Full Graduation Set</option>
                        <option value="Custom / Not Listed">Custom / Not Listed</option>
                        <option value="Not Sure">Not Sure</option>
                      </select>
                      <small data-uqm-error="stoleType"></small>
                    </div>

                    <div class="uqm__field" data-uqm-package-field="stole-tassel" hidden>
                      <label for="uqm-stole-school">School / organization</label>
                      <input id="uqm-stole-school" name="stoleSchool" type="text" maxlength="160">
                    </div>

                    <div
                      id="uqm-year-charm-field"
                      class="uqm__field"
                      data-uqm-package-field="stole-tassel"
                      hidden
                    >
                      <label class="uqm__checkbox-option" for="uqm-year-charm">
                        <input
                          id="uqm-year-charm"
                          name="yearCharm"
                          type="checkbox"
                          value="true"
                        >
                        <span>Add Year Charm</span>
                      </label>
                      <small class="uqm__hint">
                        Select this option when the tassel should include a graduation-year charm.
                      </small>
                    </div>

                    <div class="uqm__field" data-uqm-package-field="stole-tassel" hidden>
                      <label for="uqm-stole-grad-year">Graduation year</label>
                      <input
                        id="uqm-stole-grad-year"
                        name="stoleGraduationYear"
                        type="text"
                        inputmode="numeric"
                        maxlength="4"
                        pattern="[0-9]{4}"
                        placeholder="Example: 2026"
                      >
                      <small data-uqm-error="stoleGraduationYear"></small>
                    </div>

                    <div class="uqm__field uqm__field--full" data-uqm-controller-field="pe-uniform" hidden>
                      <label for="uqm-pe-package-type">PE package type *</label>
                      <select id="uqm-pe-package-type" name="pePackageType">
                        <option value="">Select package type</option>
                        <option value="T-shirt only">T-shirt only</option>
                        <option value="Shorts only">Shorts only</option>
                        <option value="T-shirt + shorts">T-shirt + shorts</option>
                        <option value="Sweatshirt + sweatpants">Sweatshirt + sweatpants</option>
                        <option value="Complete PE package">Complete PE package</option>
                        <option value="Custom combination">Custom combination</option>
                        <option value="Not Sure">Not Sure</option>
                      </select>
                      <small data-uqm-error="pePackageType"></small>
                    </div>

                    <div class="uqm__field" data-uqm-package-field="pe-uniform" hidden>
                      <label for="uqm-pe-student-level">Student level</label>
                      <select id="uqm-pe-student-level" name="peStudentLevel">
                        <option value="">Select student level</option>
                        <option value="Elementary">Elementary</option>
                        <option value="Middle school">Middle school</option>
                        <option value="High school">High school</option>
                        <option value="College">College</option>
                        <option value="Mixed grades">Mixed grades</option>
                        <option value="Not Sure">Not Sure</option>
                      </select>
                    </div>

                    <div class="uqm__field" data-uqm-package-field="pe-uniform" hidden>
                      <label for="uqm-pe-size-range">Size range</label>
                      <select id="uqm-pe-size-range" name="peSizeRange">
                        <option value="">Select size range</option>
                        <option value="Youth sizes">Youth sizes</option>
                        <option value="Adult sizes">Adult sizes</option>
                        <option value="Mixed youth and adult sizes">Mixed youth and adult sizes</option>
                        <option value="Need size chart / not sure">Need size chart / not sure</option>
                      </select>
                    </div>

                    <div class="uqm__field uqm__field--full" data-uqm-controller-field="sublimated" hidden>
                      <label for="uqm-sublimated-garment-type">Sublimated apparel type *</label>
                      <select id="uqm-sublimated-garment-type" name="sublimatedGarmentType">
                        <option value="">Select apparel type</option>
                        <option value="Basketball Uniform Set">Basketball Uniform Set</option>
                        <option value="Volleyball Uniform Set">Volleyball Uniform Set</option>
                        <option value="Soccer Uniform Set">Soccer Uniform Set</option>
                        <option value="Baseball / Softball Jersey">Baseball / Softball Jersey</option>
                        <option value="Track / Running Singlet">Track / Running Singlet</option>
                        <option value="Cheer / Dance Uniform">Cheer / Dance Uniform</option>
                        <option value="Team Jersey">Team Jersey</option>
                        <option value="Warm-up / Training Shirt">Warm-up / Training Shirt</option>
                        <option value="Custom Sublimated Apparel">Custom Sublimated Apparel</option>
                        <option value="Not Sure">Not Sure</option>
                      </select>
                      <small data-uqm-error="sublimatedGarmentType"></small>
                    </div>

                    <div class="uqm__field" data-uqm-package-field="sublimated" hidden>
                      <label for="uqm-sublimated-team-name">Team / school name</label>
                      <input id="uqm-sublimated-team-name" name="sublimatedTeamName" type="text" maxlength="160">
                    </div>

                    <div class="uqm__field" data-uqm-package-field="sublimated" hidden>
                      <label for="uqm-sublimated-season">Season / event</label>
                      <input id="uqm-sublimated-season" name="sublimatedSeason" type="text" maxlength="120" placeholder="Example: 2026 season">
                    </div>

                    <input id="uqm-product-id" name="productId" type="hidden">
                    <input id="uqm-style-id" name="selectedStyleId" type="hidden">

                    <div class="uqm__field" data-uqm-catalog-product-field>
                      <label for="uqm-manufacturer-sku">SKU / Manufacturer</label>
                      <input id="uqm-manufacturer-sku" name="manufacturerSku" type="text" maxlength="120">
                    </div>

                    <div class="uqm__field" data-uqm-catalog-product-field>
                      <label for="uqm-color">Selected color</label>
                      <input id="uqm-color" name="selectedColor" type="text" maxlength="120">
                    </div>

                    <div class="uqm__field" data-uqm-standard-quantity-field>
                      <label for="uqm-quantity">Estimated quantity *</label>
                      <input id="uqm-quantity" name="quantity" type="number" min="1" max="100000" step="1" required>
                      <small data-uqm-error="quantity"></small>
                    </div>

                    <div class="uqm__field" data-uqm-standard-quantity-field>
                      <label for="uqm-needed-by" id="uqm-needed-by-label">Needed-by date</label>
                      <input id="uqm-needed-by" name="neededByDate" type="date">
                    </div>

                    <section
                      class="uqm__mode-section uqm__mode-section--webstore uqm__mode-section--webstore-left"
                      data-uqm-mode-section="custom-webstore"
                      hidden
                    >
                      <div class="uqm__mode-banner">
                        <strong>Custom Online Store RFQ</strong>
                        <span>Tell us who the store is for and what products you want to offer.</span>
                      </div>

                      <div class="uqm__grid">
                        <div class="uqm__field">
                          <label for="uqm-webstore-organization-type">Organization type *</label>
                          <select id="uqm-webstore-organization-type" name="webstoreOrganizationType">
                            <option value="">Select organization type</option>
                            <option value="School / District">School / District</option>
                            <option value="College / University">College / University</option>
                            <option value="Team / Athletic Program">Team / Athletic Program</option>
                            <option value="Club / Student Organization">Club / Student Organization</option>
                            <option value="Business / Company">Business / Company</option>
                            <option value="Nonprofit / Community Organization">Nonprofit / Community Organization</option>
                            <option value="Event / Fundraiser">Event / Fundraiser</option>
                            <option value="Other">Other</option>
                          </select>
                          <small data-uqm-error="webstoreOrganizationType"></small>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-name">Preferred store name</label>
                          <input
                            id="uqm-webstore-name"
                            name="webstoreName"
                            type="text"
                            maxlength="180"
                            placeholder="Example: Lincoln MS Spirit Store"
                          >
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-type">Store type *</label>
                          <select id="uqm-webstore-type" name="webstoreType">
                            <option value="">Select store type</option>
                            <option value="School / Organization Store">School / Organization Store</option>
                            <option value="Spirit Wear Store">Spirit Wear Store</option>
                            <option value="Team / Athletic Store">Team / Athletic Store</option>
                            <option value="Employee / Workwear Store">Employee / Workwear Store</option>
                            <option value="Event Store">Event Store</option>
                            <option value="Fundraising Store">Fundraising Store</option>
                            <option value="Mixed / Multi-purpose Store">Mixed / Multi-purpose Store</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                          <small data-uqm-error="webstoreType"></small>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-participants">Estimated participants / customers</label>
                          <input
                            id="uqm-webstore-participants"
                            name="webstoreParticipants"
                            type="number"
                            min="1"
                            max="100000"
                            step="1"
                            placeholder="Example: 500"
                          >
                        </div>

                        <fieldset class="uqm__field uqm__field--full">
                          <legend>Products needed</legend>
                          <div id="uqm-webstore-products-grid" class="uqm__checkbox-grid">
                            <label><input type="checkbox" name="webstoreProducts" value="T-shirts"> <span>T-shirts</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Polos"> <span>Polos</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Sweatshirts"> <span>Sweatshirts</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Jackets"> <span>Jackets</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Pants / Shorts"> <span>Pants / Shorts</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Caps / Headwear"> <span>Caps / Headwear</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Bags"> <span>Bags</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Promotional Products"> <span>Promotional Products</span></label>
                            <label><input type="checkbox" name="webstoreProducts" value="Not Sure"> <span>Not Sure</span></label>
                          </div>
                        </fieldset>

                        <div class="uqm__field uqm__field--full">
                          <label for="uqm-webstore-style-count">Estimated products / styles</label>
                          <select id="uqm-webstore-style-count" name="webstoreStyleCount">
                            <option value="">Select one</option>
                            <option value="1–5 products">1–5 products</option>
                            <option value="6–10 products">6–10 products</option>
                            <option value="11–20 products">11–20 products</option>
                            <option value="More than 20 products">More than 20 products</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>
                      </div>
                    </section>
                  </div>
                </section>
              </div>

              <!-- RIGHT COLUMN -->
              <div class="uqm__column">
                <section class="uqm__section uqm__section--first">
                  <h3>Decoration and artwork</h3>

                  <div class="uqm__grid">
                    <div class="uqm__field">
                      <label for="uqm-decoration">Decoration method</label>
                      <select id="uqm-decoration" name="decorationMethod">
                        <option value="">Not sure yet</option>
                        <option value="Screen printing">Screen printing</option>
                        <option value="Embroidery">Embroidery</option>
                        <option value="Heat transfer">Heat transfer</option>
                        <option value="Direct-to-garment">Direct-to-garment</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div class="uqm__field">
                      <label for="uqm-artwork-status">Artwork status *</label>
                      <select id="uqm-artwork-status" name="artworkStatus" required>
                        <option value="">Select artwork status</option>
                        <option value="artwork-ready">I have artwork ready</option>
                        <option value="reference-only">I have a reference only</option>
                        <option value="needs-design-help">I need design help</option>
                        <option value="updating-existing-artwork">Updating existing artwork</option>
                        <option value="not-sure">Not sure yet</option>
                      </select>
                      <small data-uqm-error="artworkStatus"></small>
                    </div>

                    <div class="uqm__field uqm__field--full uqm__file-field">
                      <label for="uqm-artwork-files">Upload artwork or reference files</label>
                      <input
                        id="uqm-artwork-files"
                        name="artworkFiles"
                        type="file"
                        multiple
                        accept=".ai,.eps,.pdf,.svg,.png,.jpg,.jpeg,.webp,.psd,.tif,.tiff"
                      >
                      <small class="uqm__hint">Accepted: AI, EPS, PDF, SVG, PNG, JPG, JPEG, WEBP, PSD, TIFF. Maximum 10 files, 15 MB each, 50 MB combined.</small>
                      <small data-uqm-error="artworkFiles"></small>
                    </div>

                    <section class="uqm__mode-section uqm__mode-section--promo" data-uqm-mode-section="promotional" hidden>
                      <div class="uqm__mode-banner">
                        <strong>Promotional Item RFQ</strong>
                        <span>For lanyards, pens, mugs, bottles, tumblers, and giveaway items.</span>
                      </div>

                      <div class="uqm__grid">
                        <div class="uqm__field uqm__field--full">
                          <label for="uqm-promo-imprint-colors">Number of imprint colors</label>
                          <select id="uqm-promo-imprint-colors" name="promotionalImprintColors">
                            <option value="">Not sure yet</option>
                            <option value="1 Color">1 Color</option>
                            <option value="2 Colors">2 Colors</option>
                            <option value="3 Colors">3 Colors</option>
                            <option value="Full Color">Full Color</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                      </div>
                    </section>

                    <section class="uqm__mode-section uqm__mode-section--stole" data-uqm-mode-section="stole-tassel" hidden>
                      <div class="uqm__mode-banner">
                        <strong>Gown / Stole / Tassel RFQ</strong>
                        <span>For graduation gowns, stoles, tassels, personalization, school colors, and ceremony deadlines.</span>
                      </div>

                      <div class="uqm__grid">
                        <div class="uqm__field" data-uqm-stole-field="stole-color">
                          <label for="uqm-stole-color">Stole color</label>
                          <input id="uqm-stole-color" name="stoleColor" type="text" maxlength="80" placeholder="Example: Navy, royal, gold">
                        </div>

                        <div class="uqm__field" data-uqm-stole-field="tassel-color">
                          <label for="uqm-tassel-color">Primary tassel color *</label>
                          <select id="uqm-tassel-color" name="tasselColor">
                            <option value="">Select primary color</option>
                            ${TASSEL_COLOR_OPTIONS.map(function (color) {
                              return '<option value="' + escapeHtml(color) + '">' + escapeHtml(color) + '</option>';
                            }).join("")}
                          </select>
                          <small data-uqm-error="tasselColor"></small>
                        </div>

                        <div class="uqm__field" data-uqm-stole-field="tassel-color">
                          <label for="uqm-tassel-secondary-color">Secondary tassel color</label>
                          <select id="uqm-tassel-secondary-color" name="tasselSecondaryColor">
                            <option value="">None / single-color tassel</option>
                            ${TASSEL_COLOR_OPTIONS.map(function (color) {
                              return '<option value="' + escapeHtml(color) + '">' + escapeHtml(color) + '</option>';
                            }).join("")}
                          </select>
                          <small class="uqm__hint">Optional for a two-color tassel.</small>
                        </div>

                        <div class="uqm__field" data-uqm-stole-field="gown-color">
                          <label for="uqm-gown-color">Gown color</label>
                          <input id="uqm-gown-color" name="gownColor" type="text" maxlength="80" placeholder="Example: Navy, black, royal">
                        </div>

                        <div class="uqm__field" data-uqm-stole-field="gown-size">
                          <label for="uqm-gown-size-range">Gown size range</label>
                          <select id="uqm-gown-size-range" name="gownSizeRange">
                            <option value="">Select size range</option>
                            <option value="Youth sizes">Youth sizes</option>
                            <option value="Adult sizes">Adult sizes</option>
                            <option value="Mixed youth and adult sizes">Mixed youth and adult sizes</option>
                            <option value="Need size chart / not sure">Need size chart / not sure</option>
                          </select>
                        </div>

                        <div class="uqm__field uqm__field--full" data-uqm-stole-field="personalization">
                          <label for="uqm-stole-personalization">Personalization needed?</label>
                          <select id="uqm-stole-personalization" name="stolePersonalization">
                            <option value="">Select one</option>
                            <option value="No personalization">No personalization</option>
                            <option value="Individual student names">Individual student names</option>
                            <option value="School name only">School name only</option>
                            <option value="Graduation year only">Graduation year only</option>
                            <option value="Names + year">Names + year</option>
                            <option value="Logo / emblem only">Logo / emblem only</option>
                            <option value="Names + logo + year">Names + logo + year</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                        <div class="uqm__field uqm__field--full">
                          <small class="uqm__dynamic-hint" data-uqm-stole-dynamic-copy>
                            Select a request type to show the most relevant stole, tassel, gown, and personalization fields.
                          </small>
                        </div>
                      </div>
                    </section>


                    <section class="uqm__mode-section uqm__mode-section--pe" data-uqm-mode-section="pe-uniform" hidden>
                      <div class="uqm__mode-banner">
                        <strong>PE Uniform RFQ</strong>
                        <span>For school PE T-shirts, shorts, sweatshirts, sweatpants, and complete PE packages. Pricing is provided by our Sales Team.</span>
                      </div>

                      <div class="uqm__grid">
                        <fieldset class="uqm__field uqm__field--full">
                          <legend>PE apparel needed *</legend>
                          <div id="uqm-pe-apparel-grid" class="uqm__checkbox-grid">
                            ${PE_APPAREL_OPTIONS.map(function (item) {
                              return '<label><input type="checkbox" name="peApparel" value="' +
                                escapeHtml(item) + '"> <span>' + escapeHtml(item) + '</span></label>';
                            }).join("")}
                          </div>
                          <small data-uqm-error="peApparel"></small>
                        </fieldset>

                        <div class="uqm__field">
                          <label for="uqm-pe-primary-color">Primary garment color</label>
                          <input id="uqm-pe-primary-color" name="pePrimaryColor" type="text" maxlength="80" placeholder="Example: Royal blue">
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-pe-secondary-color">Secondary / accent color</label>
                          <input id="uqm-pe-secondary-color" name="peSecondaryColor" type="text" maxlength="80" placeholder="Example: White, gold">
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-pe-print-colors">Number of print colors</label>
                          <select id="uqm-pe-print-colors" name="pePrintColors">
                            <option value="">Not sure yet</option>
                            <option value="1 Color">1 Color</option>
                            <option value="2 Colors">2 Colors</option>
                            <option value="3 Colors">3 Colors</option>
                            <option value="Full Color">Full Color</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-pe-school-marking">School name / initials to print</label>
                          <input id="uqm-pe-school-marking" name="peSchoolMarking" type="text" maxlength="180" placeholder="Example: Lincoln MS PE">
                        </div>

                        <div class="uqm__field uqm__field--full">
                          <small class="uqm__dynamic-hint">
                            PE products and online pricing will open separately later. This form sends the requirements to Sales for a formal quote.
                          </small>
                        </div>
                      </div>
                    </section>


                    <section
                      class="uqm__mode-section uqm__mode-section--webstore uqm__mode-section--webstore-right"
                      data-uqm-mode-section="custom-webstore"
                      hidden
                    >
                      <div class="uqm__mode-banner">
                        <strong>Store setup and fulfillment</strong>
                        <span>Tell us how the store should operate, fulfill orders, and support your program.</span>
                      </div>

                      <div class="uqm__grid">
                        <div class="uqm__field">
                          <label for="uqm-webstore-schedule">Store schedule *</label>
                          <select id="uqm-webstore-schedule" name="webstoreSchedule">
                            <option value="">Select store schedule</option>
                            <option value="Always open">Always open</option>
                            <option value="Limited ordering window">Limited ordering window</option>
                            <option value="Seasonal">Seasonal</option>
                            <option value="One-time event">One-time event</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                          <small data-uqm-error="webstoreSchedule"></small>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-open-date">Preferred opening date</label>
                          <input id="uqm-webstore-open-date" name="webstoreOpenDate" type="date">
                        </div>

                        <div class="uqm__field uqm__field--full">
                          <label for="uqm-webstore-fulfillment">Fulfillment method *</label>
                          <select id="uqm-webstore-fulfillment" name="webstoreFulfillment">
                            <option value="">Select fulfillment method</option>
                            <option value="School Pickup">School Pickup</option>
                            <option value="Direct Delivery">Direct Delivery</option>
                          </select>
                          <small data-uqm-error="webstoreFulfillment"></small>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-fundraising">Fundraising / markup</label>
                          <select id="uqm-webstore-fundraising" name="webstoreFundraising">
                            <option value="">Select one</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-markup">Requested markup</label>
                          <input
                            id="uqm-webstore-markup"
                            name="webstoreMarkup"
                            type="text"
                            maxlength="80"
                            placeholder="Example: 15% or $5 per item"
                          >
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-tax-status">Tax exemption status</label>
                          <select id="uqm-webstore-tax-status" name="webstoreTaxStatus">
                            <option value="">Select one</option>
                            <option value="Tax-exempt documentation available">Tax-exempt documentation available</option>
                            <option value="Not tax exempt">Not tax exempt</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-promotion-help">Promotion assistance</label>
                          <select id="uqm-webstore-promotion-help" name="webstorePromotionHelp">
                            <option value="">Select one</option>
                            <option value="Yes — email / social graphics">Yes — email / social graphics</option>
                            <option value="Yes — launch guidance only">Yes — launch guidance only</option>
                            <option value="No">No</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-approver">Product / artwork approver</label>
                          <input
                            id="uqm-webstore-approver"
                            name="webstoreApprover"
                            type="text"
                            maxlength="180"
                            placeholder="Name and email, if different"
                          >
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-webstore-report-recipient">Store report recipient</label>
                          <input
                            id="uqm-webstore-report-recipient"
                            name="webstoreReportRecipient"
                            type="text"
                            maxlength="180"
                            placeholder="Name and email"
                          >
                        </div>

                        <div class="uqm__field uqm__field--full">
                          <small class="uqm__dynamic-hint">
                            Our team will confirm products, pricing, artwork, store setup, fulfillment, and launch timing with you.
                          </small>
                        </div>
                      </div>
                    </section>


                    <section class="uqm__mode-section uqm__mode-section--sublimated" data-uqm-mode-section="sublimated" hidden>
                      <div class="uqm__mode-banner">
                        <strong>Sublimated Apparel RFQ</strong>
                        <span>For custom athletic uniforms, jerseys, full-color team apparel, names, numbers, and sponsor logos.</span>
                      </div>

                      <div class="uqm__grid">
                        <div class="uqm__field">
                          <label for="uqm-sublimated-sport">Sport / activity</label>
                          <input id="uqm-sublimated-sport" name="sublimatedSport" type="text" maxlength="120" placeholder="Example: Basketball, Volleyball">
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-sublimated-uniform-set">Uniform set</label>
                          <select id="uqm-sublimated-uniform-set" name="sublimatedUniformSet">
                            <option value="">Select one</option>
                            <option value="Jersey only">Jersey only</option>
                            <option value="Shorts only">Shorts only</option>
                            <option value="Jersey + shorts">Jersey + shorts</option>
                            <option value="Top + bottom set">Top + bottom set</option>
                            <option value="Warm-up / training item">Warm-up / training item</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-sublimated-primary-color">Primary color</label>
                          <input id="uqm-sublimated-primary-color" name="sublimatedPrimaryColor" type="text" maxlength="80" placeholder="Example: Royal blue">
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-sublimated-secondary-color">Secondary / accent color</label>
                          <input id="uqm-sublimated-secondary-color" name="sublimatedSecondaryColor" type="text" maxlength="80" placeholder="Example: White, gold">
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-sublimated-size-range">Size range</label>
                          <select id="uqm-sublimated-size-range" name="sublimatedSizeRange">
                            <option value="">Select size range</option>
                            <option value="Youth sizes">Youth sizes</option>
                            <option value="Adult sizes">Adult sizes</option>
                            <option value="Mixed youth and adult sizes">Mixed youth and adult sizes</option>
                            <option value="Need size chart / not sure">Need size chart / not sure</option>
                          </select>
                        </div>

                        <div class="uqm__field">
                          <label for="uqm-sublimated-personalization">Names / numbers?</label>
                          <select id="uqm-sublimated-personalization" name="sublimatedPersonalization">
                            <option value="">Select one</option>
                            <option value="No personalization">No personalization</option>
                            <option value="Player numbers only">Player numbers only</option>
                            <option value="Player names only">Player names only</option>
                            <option value="Player names + numbers">Player names + numbers</option>
                            <option value="Team name only">Team name only</option>
                            <option value="Team name + player names + numbers">Team name + player names + numbers</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                        </div>

                        <div class="uqm__field uqm__field--full">
                          <label for="uqm-sublimated-design-notes">Design direction / reference</label>
                          <textarea id="uqm-sublimated-design-notes" name="sublimatedDesignNotes" rows="3" maxlength="1200" placeholder="Describe the design direction, pattern, logos, sponsor marks, or reference uniform."></textarea>
                        </div>
                      </div>
                    </section>

                    <fieldset id="uqm-print-locations-field" class="uqm__field uqm__field--full uqm__locations">
                      <legend id="uqm-print-locations-legend">Print locations</legend>
                      <div id="uqm-print-locations-grid" class="uqm__checkbox-grid">
                        <label><input type="checkbox" name="printLocations" value="Full Front"> <span>Full Front</span></label>
                        <label><input type="checkbox" name="printLocations" value="Left Chest"> <span>Left Chest</span></label>
                        <label><input type="checkbox" name="printLocations" value="Right Chest"> <span>Right Chest</span></label>
                        <label><input type="checkbox" name="printLocations" value="Full Back"> <span>Full Back</span></label>
                        <label><input type="checkbox" name="printLocations" value="Left Sleeve"> <span>Left Sleeve</span></label>
                        <label><input type="checkbox" name="printLocations" value="Right Sleeve"> <span>Right Sleeve</span></label>
                        <label><input type="checkbox" name="printLocations" value="Other"> <span>Other</span></label>
                      </div>
                      <small id="uqm-print-locations-hint" class="uqm__hint"></small>
                    </fieldset>

                    <div class="uqm__field uqm__field--full">
                      <label for="uqm-notes">Project notes</label>
                      <textarea id="uqm-notes" name="notes" rows="8" maxlength="5000" placeholder="Share any additional details about your project, artwork, quantities, or timing."></textarea>
                      <div class="uqm__meta">
                        <small data-uqm-error="notes"></small>
                        <small><span id="uqm-notes-count">0</span>/5000</small>
                      </div>
                    </div>
                  </div>
                </section>

                <input id="uqm-product-image-url" name="productImageUrl" type="hidden">
                <input id="uqm-source-page-url" name="sourcePageUrl" type="hidden">
                <input id="uqm-rfq-type" name="rfqType" type="hidden" value="general">
                <input id="uqm-package-name" name="packageName" type="hidden">

                <div class="uqm__honeypot" aria-hidden="true">
                  <label for="uqm-company-website">Company website</label>
                  <input id="uqm-company-website" name="companyWebsite" type="text" tabindex="-1" autocomplete="off">
                </div>

                <label class="uqm__consent">
                  <input id="uqm-consent" name="consent" type="checkbox" required>
                  <span>I agree that Unisource Apparel may use the information provided to respond to this quote request. *</span>
                </label>
                <small data-uqm-error="consent"></small>

                    <div class="uqm__actions">
                    <button id="uqm-submit" type="submit">
                        <span data-uqm-submit-label>Submit Quote Request</span>
                        <span class="uqm__spinner" aria-hidden="true"></span>
                    </button>

                    <a href="tel:8887438000" class="uqm__call-btn">
                        <span class="uqm__call-label">Call Sales</span>
                        <strong class="uqm__call-number">888 743 8000</strong>
                    </a>

                    <a href="/pages/request-a-quote" id="uqm-full-page-link" data-uqm-full-page>Open full page</a>
                    </div>
            </div>
          </form>

          <section id="uqm-success" class="uqm__success" hidden>
            <div class="uqm__success-icon">✓</div>
            <p class="uqm__eyebrow">Quote request received</p>
            <h3>Thank you. We have received your request.</h3>
            <p>Our team will review the details and follow up with you.</p>

            <div class="uqm__reference">
              <span>Reference number</span>
              <strong id="uqm-reference"></strong>
            </div>

            <div class="uqm__success-actions">
              <button type="button" id="uqm-another">Submit another request</button>
              <button type="button" data-uqm-close>Close</button>
            </div>
          </section>
        </div>
      </div>
    `;
  }

  function getModal() {
    return document.getElementById("unisource-quote-modal");
  }

  function getForm() {
    return document.getElementById("uqm-form");
  }

  function setValue(id, value) {
    var el = document.getElementById(id);
    if (el) el.value = value == null ? "" : String(value);
  }

  function normalizeRfqType(value) {
    var type = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/_/g, "-");

    if (
      type === "promo" ||
      type === "promotional" ||
      type === "promotional-item" ||
      type === "promotional-items"
    ) {
      return "promotional";
    }

    if (
      type === "stole" ||
      type === "stoles" ||
      type === "tassel" ||
      type === "tassels" ||
      type === "stole-tassel" ||
      type === "stoles-tassels"
    ) {
      return "stole-tassel";
    }

    if (
      type === "pe" ||
      type === "pe-rfq" ||
      type === "pe-uniform" ||
      type === "pe-uniforms" ||
      type === "physical-education" ||
      type === "physical-education-uniform"
    ) {
      return "pe-uniform";
    }

    if (
      type === "sublimated" ||
      type === "sublimation" ||
      type === "sublimated-apparel" ||
      type === "sublimated-athletic" ||
      type === "sublimated-athletic-apparel" ||
      type === "sublimated-uniform" ||
      type === "sublimated-uniforms"
    ) {
      return "sublimated";
    }

    if (
      type === "custom-webstore" ||
      type === "custom-web-store" ||
      type === "custom-online-store" ||
      type === "online-store" ||
      type === "webstore" ||
      type === "store-setup"
    ) {
      return "custom-webstore";
    }

    return "general";
  }

  function getModeLabel(rfqType) {
    if (rfqType === "promotional") return "Promotional Item RFQ";
    if (rfqType === "stole-tassel") return "Gown / Stole / Tassel RFQ";
    if (rfqType === "sublimated") return "Sublimated Apparel RFQ";
    if (rfqType === "pe-uniform") return "PE Uniform RFQ";
    if (rfqType === "custom-webstore") return "Custom Online Store RFQ";
    return "Tell us about your project";
  }

  function normalizeContext(input) {
    var data = input || {};

    return {
      productId: String(data.productId || "").trim(),
      productName: String(data.productName || "").trim(),
      manufacturerSku: String(data.manufacturerSku || "").trim(),
      selectedStyleId: String(data.selectedStyleId || data.styleId || "").trim(),
      selectedColor: String(data.selectedColor || data.color || "").trim(),
      productImageUrl: String(data.productImageUrl || data.imageUrl || "").trim(),
      sourcePageUrl: String(data.sourcePageUrl || window.location.href).trim(),
      quantity: Number(data.quantity || 1),
      rfqType: normalizeRfqType(data.rfqType || data.rfq_type || data.type),
      packageName: String(data.packageName || data.package || "").trim()
    };
  }

  function parseQuoteUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      var params = parsed.searchParams;

      return normalizeContext({
        productId: params.get("productId"),
        productName: params.get("productName"),
        manufacturerSku: params.get("manufacturerSku"),
        selectedStyleId: params.get("selectedStyleId") || params.get("styleId"),
        selectedColor: params.get("selectedColor") || params.get("color"),
        productImageUrl: params.get("productImageUrl"),
        sourcePageUrl: params.get("sourcePageUrl") || window.location.href,
        quantity: params.get("quantity") || 1,
        rfqType: params.get("rfq_type") || params.get("rfqType") || params.get("type"),
        packageName: params.get("package") || params.get("packageName")
      });
    } catch (error) {
      return normalizeContext({});
    }
  }

  function buildFullPageUrl(context) {
    var url = new URL("/pages/request-a-quote", window.location.origin);

    Object.keys(context || {}).forEach(function (key) {
      var value = context[key];
      if (value === "" || value == null) return;
      url.searchParams.set(key, String(value));
    });

    return url.pathname + url.search;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  async function loadRequestQuoteFormConfig() {
    if (state.formConfigLoaded) return state.formConfig;

    state.formConfigLoaded = true;

    try {
      var response = await fetch(FORM_CONFIG_URL, {
        method: "GET",
        cache: "no-store",
        headers: { Accept: "application/json" }
      });

      if (!response.ok) return null;

      var payload = await response.json();
      state.formConfig = payload && payload.data ? payload.data : null;
      return state.formConfig;
    } catch (error) {
      console.warn("[Unisource RFQ] Unable to load form configuration.", error);
      return null;
    }
  }

  function getConfiguredField(fieldId) {
    var fields = state.formConfig && Array.isArray(state.formConfig.fields)
      ? state.formConfig.fields
      : [];

    return fields.find(function (field) {
      return String(field && field.id || "") === String(fieldId || "");
    }) || null;
  }

  function getConditionalFieldValue(fieldId) {
    if (fieldId === "rfqType") return state.currentRfqType || "general";

    var aliases = {
      stoleType: "uqm-stole-type",
      promotionalProductType: "uqm-promo-product-type",
      sublimatedGarmentType: "uqm-sublimated-garment-type",
      pePackageType: "uqm-pe-package-type",
      artworkStatus: "uqm-artwork-status",
      decorationMethod: "uqm-decoration"
    };

    var element =
      document.getElementById(aliases[fieldId] || "") ||
      document.querySelector('[name="' + String(fieldId || "").replace(/"/g, '\\"') + '"]');

    if (!element) return "";

    if (element.type === "checkbox") return !!element.checked;

    if (element.type === "radio") {
      var selected = document.querySelector(
        'input[type="radio"][name="' + String(element.name || fieldId).replace(/"/g, '\\"') + '"]:checked'
      );
      return selected ? selected.value : "";
    }

    return String(element.value || "").trim();
  }

  function normalizeConditionToken(value) {
    return String(value == null ? "" : value)
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getConditionalFieldCandidates(fieldId) {
    if (fieldId === "rfqType") {
      return [
        state.currentRfqType || "general",
        getModeLabel(state.currentRfqType || "general")
      ];
    }

    var aliases = {
      stoleType: "uqm-stole-type",
      promotionalProductType: "uqm-promo-product-type",
      sublimatedGarmentType: "uqm-sublimated-garment-type",
      pePackageType: "uqm-pe-package-type",
      artworkStatus: "uqm-artwork-status",
      decorationMethod: "uqm-decoration"
    };

    var element =
      document.getElementById(aliases[fieldId] || "") ||
      document.querySelector(
        '[name="' +
          String(fieldId || "").replace(/"/g, '\\"') +
        '"]'
      );

    if (!element) return [""];

    if (element.type === "checkbox") {
      return [!!element.checked];
    }

    if (element.type === "radio") {
      var selectedRadio = document.querySelector(
        'input[type="radio"][name="' +
          String(element.name || fieldId).replace(/"/g, '\\"') +
        '"]:checked'
      );

      if (!selectedRadio) return [""];

      return [
        selectedRadio.value,
        selectedRadio.getAttribute("data-label") || ""
      ];
    }

    var candidates = [String(element.value || "").trim()];

    if (
      element.tagName &&
      element.tagName.toLowerCase() === "select" &&
      element.selectedIndex >= 0 &&
      element.options[element.selectedIndex]
    ) {
      candidates.push(
        String(element.options[element.selectedIndex].textContent || "").trim()
      );
    }

    return candidates;
  }

  function conditionMatches(condition) {
    var fieldId = condition && condition.sourceFieldId;
    var actualCandidates = getConditionalFieldCandidates(fieldId);
    var operator = String(
      condition && condition.operator || "equals"
    );
    var expected = condition ? condition.value : "";

    if (operator === "checked") {
      return actualCandidates.some(function (actual) {
        return actual === true;
      });
    }

    if (operator === "is-empty") {
      return actualCandidates.every(function (actual) {
        return String(actual).trim() === "";
      });
    }

    if (operator === "is-not-empty") {
      return actualCandidates.some(function (actual) {
        return String(actual).trim() !== "";
      });
    }

    var normalizedActual = actualCandidates
      .map(normalizeConditionToken)
      .filter(Boolean);

    var expectedValues = Array.isArray(expected)
      ? expected
      : [expected];

    var normalizedExpected = expectedValues
      .map(normalizeConditionToken)
      .filter(Boolean);

    if (operator === "equals") {
      return normalizedActual.some(function (actual) {
        return normalizedExpected.indexOf(actual) >= 0;
      });
    }

    if (operator === "not-equals") {
      return !normalizedActual.some(function (actual) {
        return normalizedExpected.indexOf(actual) >= 0;
      });
    }

    if (operator === "contains") {
      return normalizedActual.some(function (actual) {
        return normalizedExpected.some(function (wanted) {
          return actual.indexOf(wanted) >= 0;
        });
      });
    }

    if (operator === "one-of") {
      return normalizedActual.some(function (actual) {
        return normalizedExpected.indexOf(actual) >= 0;
      });
    }

    return false;
  }

  function renderConfiguredSelectOptions(select, options, preserveValue) {
    if (!select || !Array.isArray(options) || !options.length) return false;

    var currentValue = preserveValue ? String(select.value || "") : "";
    var hasBlank = options.some(function (option) {
      return String(option && option.value || "") === "";
    });

    select.innerHTML = "";

    if (!hasBlank) {
      var blankOption = document.createElement("option");
      blankOption.value = "";
      blankOption.textContent = "Select an option";
      select.appendChild(blankOption);
    }

    options.forEach(function (option) {
      if (!option || option.enabled === false) return;

      var node = document.createElement("option");
      node.value = String(option.value == null ? "" : option.value);
      node.textContent = String(option.label == null ? node.value : option.label);
      select.appendChild(node);
    });

    if (currentValue) {
      var stillExists = Array.prototype.some.call(select.options, function (option) {
        return option.value === currentValue;
      });
      if (stillExists) select.value = currentValue;
    }

    return true;
  }

  function getCurrentRuleContext() {
    var stoleSelect = document.getElementById("uqm-stole-type");
    var promoSelect = document.getElementById("uqm-promo-product-type");
    var sublimatedSelect = document.getElementById("uqm-sublimated-garment-type");
    var pePackageSelect = document.getElementById("uqm-pe-package-type");

    function selectCandidates(select) {
      if (!select) return [""];

      var values = [String(select.value || "").trim()];

      if (
        select.selectedIndex >= 0 &&
        select.options &&
        select.options[select.selectedIndex]
      ) {
        values.push(
          String(
            select.options[select.selectedIndex].textContent || ""
          ).trim()
        );
      }

      return values;
    }

    return {
      rfqType: [
        state.currentRfqType || "general",
        document.getElementById("uqm-rfq-type")
          ? document.getElementById("uqm-rfq-type").value
          : "",
        getModeLabel(state.currentRfqType || "general")
      ],
      stoleType: selectCandidates(stoleSelect),
      promotionalProductType: selectCandidates(promoSelect),
      sublimatedGarmentType: selectCandidates(sublimatedSelect),
      pePackageType: selectCandidates(pePackageSelect)
    };
  }

  function ruleConditionMatchesCurrentContext(condition, context) {
    var sourceFieldId = String(
      condition && condition.sourceFieldId || ""
    ).trim();

    var operator = String(
      condition && condition.operator || "equals"
    ).trim();

    var expectedValues = Array.isArray(condition && condition.value)
      ? condition.value
      : [condition ? condition.value : ""];

    var actualValues =
      context && Array.isArray(context[sourceFieldId])
        ? context[sourceFieldId]
        : getConditionalFieldCandidates(sourceFieldId);

    var normalizedActual = actualValues
      .map(normalizeConditionToken)
      .filter(Boolean);

    var normalizedExpected = expectedValues
      .map(normalizeConditionToken)
      .filter(Boolean);

    if (operator === "is-empty") {
      return normalizedActual.length === 0;
    }

    if (operator === "is-not-empty") {
      return normalizedActual.length > 0;
    }

    if (operator === "checked") {
      return actualValues.some(function (value) {
        return value === true;
      });
    }

    if (operator === "not-equals") {
      return !normalizedActual.some(function (actual) {
        return normalizedExpected.indexOf(actual) >= 0;
      });
    }

    if (operator === "contains") {
      return normalizedActual.some(function (actual) {
        return normalizedExpected.some(function (expected) {
          return actual.indexOf(expected) >= 0;
        });
      });
    }

    return normalizedActual.some(function (actual) {
      return normalizedExpected.indexOf(actual) >= 0;
    });
  }

  function findConfiguredOptionRule(fieldId) {
    var field = getConfiguredField(fieldId);
    if (!field) return null;

    var rules = Array.isArray(field.optionRules)
      ? field.optionRules
      : [];

    var context = getCurrentRuleContext();

    for (var i = 0; i < rules.length; i += 1) {
      var rule = rules[i] || {};
      var conditions = Array.isArray(rule.conditions)
        ? rule.conditions
        : [];

      if (!conditions.length) continue;

      var matches = String(rule.match || "all") === "any"
        ? conditions.some(function (condition) {
            return ruleConditionMatchesCurrentContext(
              condition,
              context
            );
          })
        : conditions.every(function (condition) {
            return ruleConditionMatchesCurrentContext(
              condition,
              context
            );
          });

      if (matches) return rule;
    }

    return null;
  }

  function configuredRawOptionsForField(fieldId) {
    var field = getConfiguredField(fieldId);
    if (!field) return null;

    var matchingRule = findConfiguredOptionRule(fieldId);

    if (matchingRule) {
      return (
        Array.isArray(matchingRule.options)
          ? matchingRule.options
          : []
      ).filter(function (option) {
        return option && option.enabled !== false;
      });
    }

    return (Array.isArray(field.options) ? field.options : [])
      .filter(function (option) {
        return option && option.enabled !== false;
      });
  }

  function configuredOptionsForField(fieldId) {
    var field = getConfiguredField(fieldId);
    if (!field) return null;

    var matchingRule = findConfiguredOptionRule(fieldId);
    var sourceOptions = matchingRule
      ? matchingRule.options
      : field.options;

    return (Array.isArray(sourceOptions) ? sourceOptions : [])
      .filter(function (option) {
        return option && option.enabled !== false;
      })
      .map(function (option) {
        return String(
          option.label || option.value || ""
        ).trim();
      })
      .filter(Boolean);
  }

  function applyConfiguredChoiceOptions() {
    /*
     * Ordinary choice fields may be rebuilt from Admin Form Manager data.
     * RFQ mode controller selects are deliberately excluded here because
     * rebuilding a controller during its own change event destroys the
     * selected option and collapses the dependent package UI.
     */
    var mappings = [
      { fieldId: "decorationMethod", elementId: "uqm-decoration" },
      { fieldId: "artworkStatus", elementId: "uqm-artwork-status" },
      { fieldId: "promotionalImprintColors", elementId: "uqm-promo-imprint-colors" },
      { fieldId: "gownSizeRange", elementId: "uqm-gown-size-range" },
      { fieldId: "stolePersonalization", elementId: "uqm-stole-personalization" },
      { fieldId: "sublimatedUniformSet", elementId: "uqm-sublimated-uniform-set" },
      { fieldId: "sublimatedSizeRange", elementId: "uqm-sublimated-size-range" },
      { fieldId: "sublimatedPersonalization", elementId: "uqm-sublimated-personalization" },
      { fieldId: "peStudentLevel", elementId: "uqm-pe-student-level" },
      { fieldId: "peSizeRange", elementId: "uqm-pe-size-range" },
      { fieldId: "pePrintColors", elementId: "uqm-pe-print-colors" },
      { fieldId: "webstoreOrganizationType", elementId: "uqm-webstore-organization-type" },
      { fieldId: "webstoreType", elementId: "uqm-webstore-type" },
      { fieldId: "webstoreStyleCount", elementId: "uqm-webstore-style-count" },
      { fieldId: "webstoreSchedule", elementId: "uqm-webstore-schedule" },
      { fieldId: "webstoreFulfillment", elementId: "uqm-webstore-fulfillment" },
      { fieldId: "webstoreFundraising", elementId: "uqm-webstore-fundraising" }
    ];

    mappings.forEach(function (mapping) {
      var select = document.getElementById(mapping.elementId);
      if (!select) return;

      var options = configuredRawOptionsForField(mapping.fieldId);
      if (!options || !options.length) return;

      renderConfiguredSelectOptions(select, options, true);
    });
  }

  function applyConfiguredControllerOptionsOnce() {
    var mappings = [
      { fieldId: "promotionalProductType", elementId: "uqm-promo-product-type" },
      { fieldId: "stoleType", elementId: "uqm-stole-type" },
      { fieldId: "sublimatedGarmentType", elementId: "uqm-sublimated-garment-type" },
      { fieldId: "pePackageType", elementId: "uqm-pe-package-type" }
    ];

    mappings.forEach(function (mapping) {
      var select = document.getElementById(mapping.elementId);
      if (!select || select.dataset.uqmConfiguredOnce === "true") return;

      var options = configuredRawOptionsForField(mapping.fieldId);
      if (!options || !options.length) return;

      renderConfiguredSelectOptions(select, options, true);
      select.dataset.uqmConfiguredOnce = "true";
    });
  }

  function configuredContentForMode() {
    var form = state.formConfig || {};
    var base = form.content || {};
    var modeContent = form.modeContent && form.modeContent[state.currentRfqType]
      ? form.modeContent[state.currentRfqType]
      : {};

    return {
      eyebrow: modeContent.eyebrow || base.eyebrow || "Request a Quote",
      heading: modeContent.heading || base.heading || getModeLabel(state.currentRfqType),
      subheading: modeContent.subheading || base.subheading || "",
      productSectionHeading: modeContent.productSectionHeading || "",
      decorationSectionHeading: modeContent.decorationSectionHeading || "",
      bannerTitle: modeContent.bannerTitle || "",
      bannerDescription: modeContent.bannerDescription || "",
      submitLabel: modeContent.submitLabel || base.submitLabel || "Submit Quote Request",
      consentText: modeContent.consentText || base.consentText || "",
      successHeading: modeContent.successHeading || base.successHeading || "",
      successText: modeContent.successText || base.successText || ""
    };
  }

  function applyConfiguredContent() {
    var content = configuredContentForMode();
    var eyebrow = document.querySelector("#unisource-quote-modal .uqm__eyebrow");
    var title = document.getElementById("uqm-title");
    var subheading = document.querySelector("#unisource-quote-modal .uqm__header > p:last-child");
    var submitLabel = document.querySelector("[data-uqm-submit-label]");
    var consentText = document.querySelector("#unisource-quote-modal .uqm__consent span");
    var successHeading = document.querySelector("#uqm-success h3");
    var successParagraphs = document.querySelectorAll("#uqm-success > p");

    if (eyebrow) eyebrow.textContent = content.eyebrow;
    if (title) title.textContent = content.heading;
    if (subheading) subheading.textContent = content.subheading;
    if (submitLabel) submitLabel.textContent = content.submitLabel;
    if (consentText && content.consentText) consentText.textContent = content.consentText + " *";
    if (successHeading && content.successHeading) successHeading.textContent = content.successHeading;
    if (successParagraphs.length > 1 && content.successText) successParagraphs[1].textContent = content.successText;

    var productSectionTitle = document.getElementById("uqm-product-section-title");
    var decorationSectionTitle = document.querySelector(
      "#unisource-quote-modal .uqm__column:nth-child(2) .uqm__section--first > h3"
    );
    var activeModeSection = document.querySelector(
      '[data-uqm-mode-section="' + state.currentRfqType + '"]'
    );
    var bannerTitle = activeModeSection
      ? activeModeSection.querySelector(".uqm__mode-banner strong")
      : null;
    var bannerDescription = activeModeSection
      ? activeModeSection.querySelector(".uqm__mode-banner span")
      : null;

    if (productSectionTitle && content.productSectionHeading) {
      productSectionTitle.textContent = content.productSectionHeading;
    }
    if (decorationSectionTitle && content.decorationSectionHeading) {
      decorationSectionTitle.textContent = content.decorationSectionHeading;
    }
    if (bannerTitle && content.bannerTitle) {
      bannerTitle.textContent = content.bannerTitle;
    }
    if (bannerDescription && content.bannerDescription) {
      bannerDescription.textContent = content.bannerDescription;
    }
  }

  function configuredFieldElement(fieldId) {
    var aliases = {
      name: "uqm-name", organization: "uqm-organization", email: "uqm-email", phone: "uqm-phone",
      productName: "uqm-product-name", manufacturerSku: "uqm-manufacturer-sku", manufacturer: "uqm-manufacturer-sku",
      selectedColor: "uqm-color", estimatedQuantity: "uqm-quantity", quantity: "uqm-quantity",
      neededByDate: "uqm-needed-by", decorationMethod: "uqm-decoration", artworkStatus: "uqm-artwork-status",
      artworkFiles: "uqm-artwork-files", printLocations: "uqm-print-locations-grid", projectNotes: "uqm-notes",
      notes: "uqm-notes", consent: "uqm-consent", promotionalProductType: "uqm-promo-product-type",
      promotionalImprintColors: "uqm-promo-imprint-colors", stoleType: "uqm-stole-type",
      stoleSchool: "uqm-stole-school", yearCharm: "uqm-year-charm",
      stoleGraduationYear: "uqm-stole-grad-year", stoleColor: "uqm-stole-color",
      tasselColor: "uqm-tassel-color", gownColor: "uqm-gown-color", gownSizeRange: "uqm-gown-size-range",
      stolePersonalization: "uqm-stole-personalization", sublimatedGarmentType: "uqm-sublimated-garment-type",
      sublimatedTeamName: "uqm-sublimated-team-name", sublimatedSeason: "uqm-sublimated-season",
      sublimatedSport: "uqm-sublimated-sport", sublimatedUniformSet: "uqm-sublimated-uniform-set",
      sublimatedPrimaryColor: "uqm-sublimated-primary-color", sublimatedSecondaryColor: "uqm-sublimated-secondary-color",
      sublimatedSizeRange: "uqm-sublimated-size-range", sublimatedPersonalization: "uqm-sublimated-personalization",
      sublimatedDesignNotes: "uqm-sublimated-design-notes",
      pePackageType: "uqm-pe-package-type", peStudentLevel: "uqm-pe-student-level",
      peSizeRange: "uqm-pe-size-range", pePrimaryColor: "uqm-pe-primary-color",
      peSecondaryColor: "uqm-pe-secondary-color", pePrintColors: "uqm-pe-print-colors",
      peSchoolMarking: "uqm-pe-school-marking", peApparel: "uqm-pe-apparel-grid",
      webstoreOrganizationType: "uqm-webstore-organization-type",
      webstoreName: "uqm-webstore-name",
      webstoreType: "uqm-webstore-type",
      webstoreParticipants: "uqm-webstore-participants",
      webstoreProducts: "uqm-webstore-products-grid",
      webstoreStyleCount: "uqm-webstore-style-count",
      webstoreSchedule: "uqm-webstore-schedule",
      webstoreOpenDate: "uqm-webstore-open-date",
      webstoreCloseDate: "uqm-webstore-open-date",
      webstoreFulfillment: "uqm-webstore-fulfillment",
      webstoreFundraising: "uqm-webstore-fundraising",
      webstoreMarkup: "uqm-webstore-markup",
      webstoreTaxStatus: "uqm-webstore-tax-status",
      webstorePromotionHelp: "uqm-webstore-promotion-help",
      webstoreApprover: "uqm-webstore-approver",
      webstoreReportRecipient: "uqm-webstore-report-recipient"
    };

    return document.getElementById(aliases[fieldId] || "") ||
      document.querySelector('[name="' + String(fieldId || "").replace(/"/g, '\\"') + '"]');
  }

  function configuredFieldWrapper(fieldId, element) {
    if (fieldId === "printLocations") {
      return document.getElementById("uqm-print-locations-field");
    }

    if (fieldId === "consent") {
      return element
        ? element.closest(".uqm__consent")
        : null;
    }

    if (!element) return null;

    /*
     * Never use the entire RFQ mode container as an individual field wrapper.
     * Doing so lets a conditional field hide the whole Graduation,
     * Promotional, or Sublimated package section.
     */
    return (
      element.closest("[data-uqm-stole-field]") ||
      element.closest(".uqm__field") ||
      element.closest("fieldset") ||
      element.parentElement
    );
  }

  function ruleMatches(rule) {
    if (!rule || !Array.isArray(rule.conditions) || !rule.conditions.length) return true;
    return String(rule.match || "all") === "any"
      ? rule.conditions.some(conditionMatches)
      : rule.conditions.every(conditionMatches);
  }

  function updateModeControllerVisibility() {
    document
      .querySelectorAll("[data-uqm-controller-field]")
      .forEach(function (wrapper) {
        var mode =
          wrapper.getAttribute("data-uqm-controller-field");

        var active = mode === state.currentRfqType;

        wrapper.hidden = !active;

        if (active) {
          wrapper.removeAttribute("aria-hidden");
          wrapper.style.removeProperty("display");

          wrapper
            .querySelectorAll("input, select, textarea")
            .forEach(function (control) {
              control.disabled = false;
            });
        } else {
          wrapper.setAttribute("aria-hidden", "true");

          wrapper
            .querySelectorAll("input, select, textarea")
            .forEach(function (control) {
              control.disabled = true;
            });
        }
      });
  }

  function restoreActiveModeContainers() {
    document
      .querySelectorAll("[data-uqm-mode-section]")
      .forEach(function (section) {
        var sectionType =
          section.getAttribute("data-uqm-mode-section");

        section.hidden =
          sectionType !== state.currentRfqType;

        if (sectionType === state.currentRfqType) {
          section.style.removeProperty("display");
          section.removeAttribute("aria-hidden");
        }
      });

    /*
     * Do not force every data-uqm-package-field back open here.
     * Graduation-specific visibility is owned by updateStoleDynamicFields().
     */
    updateModeControllerVisibility();
  }

  function applyConfiguredFieldRules() {
    var fields = state.formConfig && Array.isArray(state.formConfig.fields) ? state.formConfig.fields : [];

    fields.forEach(function (field) {
      var fieldId = String(field && field.id || "");
      if (!fieldId || field.type === "hidden") return;

      if (
        fieldId === "stoleType" ||
        fieldId === "promotionalProductType" ||
        fieldId === "sublimatedGarmentType" ||
        fieldId === "pePackageType"
      ) {
        return;
      }

      var element = configuredFieldElement(fieldId);
      var wrapper = configuredFieldWrapper(fieldId, element);
      if (!wrapper) return;

      var modes = Array.isArray(field.showInModes) ? field.showInModes : [];
      var modeVisible = !modes.length || modes.indexOf(state.currentRfqType) >= 0;
      var conditionVisible = !field.showWhen || ruleMatches(field.showWhen);
      var visible = field.visible !== false && field.enabled !== false && modeVisible && conditionVisible;

      wrapper.hidden = !visible;
      wrapper.querySelectorAll("input, select, textarea, button").forEach(function (control) {
        control.disabled = !visible || field.enabled === false;
      });

      if (!element) return;
      var required = visible && (field.required === true || (field.requireWhen && ruleMatches(field.requireWhen)));
      element.required = required;
      element.setAttribute("aria-required", required ? "true" : "false");

      if ("placeholder" in element && field.placeholder != null) {
        element.placeholder = String(field.placeholder || "");
      }

      /*
       * Apply Admin-maintained labels to the hardcoded modal controls.
       * Previously the Admin values controlled visibility and requirement only,
       * leaving labels such as "Preferred closing date" unchanged.
       */
      var label =
        wrapper.querySelector('label[for="' + String(element.id || "").replace(/"/g, '\\"') + '"]') ||
        wrapper.querySelector("legend");

      if (label && field.label) {
        label.textContent =
          String(field.label) + (required ? " *" : "");
      }

      var hint = wrapper.querySelector(".uqm__hint");
      if (hint && field.helpText) {
        hint.textContent = String(field.helpText);
      }
    });

    restoreActiveModeContainers();
  }

  function getCheckedPrintLocations() {
    var form = getForm();
    if (!form) return [];

    return Array.prototype.map.call(
      form.querySelectorAll('input[name="printLocations"]:checked'),
      function (el) { return el.value; }
    );
  }



  var STOLE_REQUEST_CONFIG = {
    "Stole Only": {
      decorationMethods: ["Embroidery", "Screen printing", "Full color print", "Patch", "Metallic / foil", "Not Sure"],
      placements: ["Left panel", "Right panel", "Both panels", "Bottom ends", "Back side", "Not Sure"],
      showStoleColor: true,
      showTasselColor: false,
      showGownColor: false,
      showGownSize: false,
      showPersonalization: true,
      notesRequired: false
    },
    "Tassel Only": {
      decorationMethods: ["Tassel charm / tag", "Year charm", "Custom tag", "No decoration", "Not Sure"],
      placements: ["Tassel charm / tag", "Cord", "No decoration", "Not Sure"],
      showStoleColor: false,
      showTasselColor: true,
      showGownColor: false,
      showGownSize: false,
      showPersonalization: true,
      notesRequired: false
    },
    "Gown Only": {
      decorationMethods: ["No decoration", "Embroidery", "Patch", "Not Sure"],
      placements: ["Left chest", "Right chest", "Sleeve", "Back", "No decoration", "Not Sure"],
      showStoleColor: false,
      showTasselColor: false,
      showGownColor: true,
      showGownSize: true,
      showPersonalization: false,
      notesRequired: false
    },
    "Stole + Tassel Set": {
      decorationMethods: ["Print", "Embroidery"],
      placements: ["Left panel", "Right panel"],
      showStoleColor: true,
      showTasselColor: true,
      showGownColor: false,
      showGownSize: false,
      showPersonalization: true,
      notesRequired: false
    },
    "Cap + Gown Set": {
      decorationMethods: ["No decoration", "Embroidery", "Patch", "Not Sure"],
      placements: ["Gown left chest", "Gown right chest", "Gown sleeve", "Gown back", "Cap top", "No decoration", "Not Sure"],
      showStoleColor: false,
      showTasselColor: false,
      showGownColor: true,
      showGownSize: true,
      showPersonalization: false,
      notesRequired: false
    },
    "Cap + Gown + Tassel Set": {
      decorationMethods: ["No decoration", "Embroidery", "Patch", "Tassel charm / tag", "Not Sure"],
      placements: ["Gown left chest", "Gown sleeve", "Cap top", "Tassel charm / tag", "No decoration", "Not Sure"],
      showStoleColor: false,
      showTasselColor: true,
      showGownColor: true,
      showGownSize: true,
      showPersonalization: true,
      notesRequired: false
    },
    "Full Graduation Set": {
      decorationMethods: ["Embroidery", "Screen printing", "Full color print", "Patch", "Metallic / foil", "Tassel charm / tag", "Not Sure"],
      placements: ["Stole left panel", "Stole right panel", "Both stole panels", "Gown left chest", "Gown sleeve", "Cap top", "Tassel charm / tag", "Not Sure"],
      showStoleColor: true,
      showTasselColor: true,
      showGownColor: true,
      showGownSize: true,
      showPersonalization: true,
      notesRequired: false
    },
    "Custom / Not Listed": {
      decorationMethods: ["Embroidery", "Screen printing", "Full color print", "Patch", "Metallic / foil", "Tassel charm / tag", "Not Sure"],
      placements: ["Stole", "Gown", "Cap", "Tassel", "Multiple items", "Not Sure"],
      showStoleColor: true,
      showTasselColor: true,
      showGownColor: true,
      showGownSize: true,
      showPersonalization: true,
      notesRequired: true
    },
    "Not Sure": {
      decorationMethods: ["Embroidery", "Screen printing", "Full color print", "Patch", "Metallic / foil", "Tassel charm / tag", "Not Sure"],
      placements: ["Stole", "Gown", "Cap", "Tassel", "Multiple items", "Not Sure"],
      showStoleColor: true,
      showTasselColor: true,
      showGownColor: true,
      showGownSize: true,
      showPersonalization: true,
      notesRequired: true
    }
  };

  function getStoleRequestType() {
    var select = document.getElementById("uqm-stole-type");
    return select ? String(select.value || "").trim() : "";
  }

  function getStoleRequestConfig() {
    var requestType = getStoleRequestType();

    if (STOLE_REQUEST_CONFIG[requestType]) {
      return STOLE_REQUEST_CONFIG[requestType];
    }

    return STOLE_REQUEST_CONFIG["Not Sure"];
  }

  function setStoleFieldVisibility(selector, visible) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.hidden = !visible;

      el.querySelectorAll("input, select, textarea").forEach(function (field) {
        field.disabled = !visible;
      });
    });
  }

  function setFieldVisibilityById(elementId, visible) {
    var element = document.getElementById(elementId);
    if (!element) return;

    var wrapper =
      element.closest(".uqm__field") ||
      element.parentElement;

    if (!wrapper) return;

    wrapper.hidden = !visible;

    wrapper
      .querySelectorAll("input, select, textarea")
      .forEach(function (field) {
        field.disabled = !visible;

        if (!visible) {
          if (field.type === "checkbox" || field.type === "radio") {
            field.checked = false;
          } else if (field.tagName.toLowerCase() === "select") {
            field.selectedIndex = 0;
          } else if (field.id !== "uqm-stole-grad-year") {
            field.value = "";
          }
        }
      });
  }

  function isYearCharmSelected() {
    var checkbox = document.getElementById("uqm-year-charm");
    return !!(checkbox && checkbox.checked && !checkbox.disabled);
  }

  function updateYearCharmRequirement() {
    var checkbox = document.getElementById("uqm-year-charm");
    var graduationYear = document.getElementById("uqm-stole-grad-year");
    var selectedType = getStoleRequestType();
    var isTasselOnly =
      state.currentRfqType === "stole-tassel" &&
      selectedType === "Tassel Only";

    setFieldVisibilityById("uqm-year-charm", isTasselOnly);

    if (!checkbox || !graduationYear) return;

    if (!isTasselOnly) {
      checkbox.checked = false;
    }

    var required = isTasselOnly && checkbox.checked;
    graduationYear.required = required;
    graduationYear.setAttribute("aria-required", required ? "true" : "false");

    var wrapper = graduationYear.closest(".uqm__field");
    var label = wrapper
      ? wrapper.querySelector('label[for="uqm-stole-grad-year"]')
      : null;

    if (label) {
      label.textContent = "Graduation year" + (required ? " *" : "");
    }

    if (!required) {
      graduationYear.setAttribute("aria-invalid", "false");

      if (wrapper) {
        wrapper.classList.remove("is-invalid");
      }

      var error = document.querySelector(
        '[data-uqm-error="stoleGraduationYear"]'
      );

      if (error) {
        error.textContent = "";
      }
    }
  }

  function applyTasselOnlyLayout(isTasselOnly) {
    /*
     * Tassel-only requests only need the graduation year from the
     * graduation-specific product details. Common contact, artwork,
     * upload, notes, consent, and submission controls remain available.
     */
    setFieldVisibilityById("uqm-stole-school", !isTasselOnly);
    setFieldVisibilityById("uqm-quantity", !isTasselOnly);
    setFieldVisibilityById("uqm-needed-by", !isTasselOnly);

    /* Graduation year remains available; it becomes required for Year Charm. */
    setFieldVisibilityById("uqm-stole-grad-year", true);
    setFieldVisibilityById("uqm-year-charm", isTasselOnly);

    if (isTasselOnly) {
      setStoleFieldVisibility(
        "[data-uqm-stole-field='stole-color']",
        false
      );
      setStoleFieldVisibility(
        "[data-uqm-stole-field='tassel-color']",
        true
      );
      setStoleFieldVisibility(
        "[data-uqm-stole-field='gown-color']",
        false
      );
      setStoleFieldVisibility(
        "[data-uqm-stole-field='gown-size']",
        false
      );
      setStoleFieldVisibility(
        "[data-uqm-stole-field='personalization']",
        false
      );
    }

    updateYearCharmRequirement();
  }

  function isNoDecorationGraduationType(requestType) {
    var type = String(requestType || getStoleRequestType() || "").trim();

    return (
      state.currentRfqType === "stole-tassel" &&
      (
        type === "Tassel Only" ||
        type === "Gown Only" ||
        type === "Cap + Gown Set" ||
        type === "Cap + Gown + Tassel Set"
      )
    );
  }

  function isStoleDecorationGraduationType(requestType) {
    var type = String(requestType || getStoleRequestType() || "").trim();

    return (
      state.currentRfqType === "stole-tassel" &&
      (
        type === "Stole Only" ||
        type === "Stole + Tassel Set" ||
        type === "Full Graduation Set"
      )
    );
  }

  function setNoDecorationControlVisibility(hidden) {
    var decoration = document.getElementById("uqm-decoration");
    var decorationWrapper = decoration
      ? decoration.closest(".uqm__field")
      : null;

    if (decorationWrapper) {
      decorationWrapper.hidden = !!hidden;

      if (hidden) {
        decorationWrapper.setAttribute("aria-hidden", "true");
        decorationWrapper.style.setProperty("display", "none", "important");
      } else {
        decorationWrapper.removeAttribute("aria-hidden");
        decorationWrapper.style.removeProperty("display");
      }
    }

    if (decoration) {
      decoration.disabled = !!hidden;

      if (hidden) {
        decoration.innerHTML =
          '<option value="No decoration needed" selected>No decoration needed</option>';
        decoration.value = "No decoration needed";
      }
    }

    var placementField =
      document.getElementById("uqm-print-locations-field");

    if (placementField) {
      placementField.hidden = !!hidden;

      if (hidden) {
        placementField.setAttribute("aria-hidden", "true");
        placementField.style.setProperty("display", "none", "important");
      } else {
        placementField.removeAttribute("aria-hidden");
        placementField.style.removeProperty("display");
      }
    }

    document
      .querySelectorAll(
        '#uqm-print-locations-grid input[name="printLocations"]'
      )
      .forEach(function (input) {
        input.checked = false;
        input.disabled = !!hidden;
      });
  }

  function setSublimationDecorationVisibility(hidden) {
    var decoration = document.getElementById("uqm-decoration");
    var wrapper = decoration
      ? decoration.closest(".uqm__field")
      : null;

    if (wrapper) {
      wrapper.hidden = !!hidden;

      if (hidden) {
        wrapper.setAttribute("aria-hidden", "true");
        wrapper.style.setProperty("display", "none", "important");
      } else {
        wrapper.removeAttribute("aria-hidden");
        wrapper.style.removeProperty("display");
      }
    }

    if (!decoration) return;

    decoration.disabled = !!hidden;

    if (hidden) {
      decoration.innerHTML =
        '<option value="Sublimation" selected>Sublimation</option>';
      decoration.value = "Sublimation";
    }
  }

  function setPromotionalDecorationFieldsVisibility(hidden) {
    var decoration = document.getElementById("uqm-decoration");
    var decorationWrapper = decoration
      ? decoration.closest(".uqm__field")
      : null;

    var imprintColors = document.getElementById(
      "uqm-promo-imprint-colors"
    );
    var imprintColorsWrapper = imprintColors
      ? imprintColors.closest(".uqm__field")
      : null;

    var placementField = document.getElementById(
      "uqm-print-locations-field"
    );

    [
      decorationWrapper,
      imprintColorsWrapper,
      placementField
    ].forEach(function (wrapper) {
      if (!wrapper) return;

      wrapper.hidden = !!hidden;

      if (hidden) {
        wrapper.setAttribute("aria-hidden", "true");
        wrapper.style.setProperty(
          "display",
          "none",
          "important"
        );
      } else {
        wrapper.removeAttribute("aria-hidden");
        wrapper.style.removeProperty("display");
      }
    });

    if (decoration) {
      decoration.disabled = !!hidden;

      if (hidden) {
        decoration.value = "";
      }
    }

    if (imprintColors) {
      imprintColors.disabled = !!hidden;

      if (hidden) {
        imprintColors.value = "";
      }
    }

    document
      .querySelectorAll(
        '#uqm-print-locations-grid input[name="printLocations"]'
      )
      .forEach(function (input) {
        input.checked = false;
        input.disabled = !!hidden;
      });
  }

  function updateStoleDynamicFields() {
    if (state.currentRfqType !== "stole-tassel") return;

    var config = getStoleRequestConfig();
    var requestType = getStoleRequestType();
    var isTasselOnly = requestType === "Tassel Only";
    var tasselColor = document.getElementById("uqm-tassel-color");

    if (tasselColor) {
      tasselColor.required = isTasselOnly;
      tasselColor.setAttribute(
        "aria-required",
        isTasselOnly ? "true" : "false"
      );
    }

    setStoleFieldVisibility(
      "[data-uqm-stole-field='stole-color']",
      config.showStoleColor
    );
    setStoleFieldVisibility(
      "[data-uqm-stole-field='tassel-color']",
      config.showTasselColor
    );
    setStoleFieldVisibility(
      "[data-uqm-stole-field='gown-color']",
      config.showGownColor
    );
    setStoleFieldVisibility(
      "[data-uqm-stole-field='gown-size']",
      config.showGownSize
    );
    setStoleFieldVisibility(
      "[data-uqm-stole-field='personalization']",
      config.showPersonalization
    );

    /*
     * Apply this last so neither the built-in request configuration nor
     * Form Manager visibility can restore Tassel-only fields.
     */
    applyTasselOnlyLayout(isTasselOnly);

    /*
     * Tassel Only and Gown Only are supplied undecorated.
     * Their fixed values are retained in the submission payload while the
     * irrelevant controls stay out of the customer-facing form.
     */
    setNoDecorationControlVisibility(
      isNoDecorationGraduationType(requestType)
    );

    var modeSubcopy = document.querySelector(
      "[data-uqm-stole-dynamic-copy]"
    );

    if (modeSubcopy) {
      if (!requestType) {
        modeSubcopy.textContent =
          "Select a request type to show the most relevant stole, tassel, gown, and personalization fields.";
      } else if (isTasselOnly) {
        modeSubcopy.textContent =
          "For tassel-only requests, select the primary tassel color, add an optional secondary color, and provide the graduation year when a Year Charm is requested.";
      } else if (
        requestType.indexOf("Gown") >= 0 ||
        requestType === "Full Graduation Set"
      ) {
        modeSubcopy.textContent =
          "Fields are adjusted for graduation apparel sets, including gown color, size range, tassel, and personalization when applicable.";
      } else if (requestType.indexOf("Tassel") >= 0) {
        modeSubcopy.textContent =
          "Fields are adjusted for tassel details and personalization when applicable.";
      } else {
        modeSubcopy.textContent =
          "Fields are adjusted for stole details, colors, decoration, and personalization.";
      }
    }
  }

  function shouldRequireNotesForStoleType(requestType) {
    var type = String(requestType || "").trim().toLowerCase();

    return (
      type === "custom / not listed" ||
      type === "not sure"
    );
  }


  function shouldRequireNotesForPromoType(productType) {
    var type = String(productType || "").trim().toLowerCase();

    return (
      type === "giveaways / event items" ||
      type === "other" ||
      type === "not sure"
    );
  }

  function updateProjectNotesRequirement() {
    var notes = document.getElementById("uqm-notes");
    var notesLabel = document.querySelector('label[for="uqm-notes"]');
    var promoType = document.getElementById("uqm-promo-product-type");

    if (!notes) return;

    var required =
      (
        state.currentRfqType === "promotional" &&
        promoType &&
        shouldRequireNotesForPromoType(promoType.value)
      ) ||
      (
        state.currentRfqType === "stole-tassel" &&
        shouldRequireNotesForStoleType(getStoleRequestType())
      ) ||
      state.currentRfqType === "sublimated" ||
      state.currentRfqType === "pe-uniform";

    notes.required = required;
    notes.setAttribute("aria-required", required ? "true" : "false");
    notes.classList.toggle("uqm__textarea--required", required);

    if (notesLabel) {
      notesLabel.textContent = required
        ? "Project notes *"
        : "Project notes";
    }

    notes.placeholder = required
      ? "Please describe the item, intended use, size/specs, target budget, preferred material, color, imprint details, or any reference item you have in mind."
      : "Share any additional details about your project, artwork, quantities, or timing.";
  }

  function getPromotionalProductType() {
    var select = document.getElementById("uqm-promo-product-type");
    return select ? String(select.value || "").trim() : "";
  }

  function getPromotionalLocationOptions(productType) {
    var type = String(productType || "").trim();

    if (PROMOTIONAL_IMPRINT_LOCATIONS[type]) {
      return PROMOTIONAL_IMPRINT_LOCATIONS[type];
    }

    return ["Front", "Back", "One Side", "Both Sides", "Multiple Locations", "Not Sure"];
  }

  function getPromotionalDecorationOptions(productType) {
    var type = String(productType || "").trim();

    if (PROMOTIONAL_DECORATION_METHODS[type]) {
      return PROMOTIONAL_DECORATION_METHODS[type];
    }

    return ["Pad print", "Screen printing", "Full color print", "Laser engraving", "Embroidery", "Not Sure"];
  }

  function renderDecorationMethodOptions(options, selectedValue) {
    var select = document.getElementById("uqm-decoration");
    if (!select) return;

    var current = String(selectedValue || select.value || "").trim();
    var optionValues = options || [];

    var html = '<option value="">Not sure yet</option>' + optionValues.map(function (label) {
      var safeLabel = escapeHtml(label);
      var selected = current === label ? " selected" : "";
      return '<option value="' + safeLabel + '"' + selected + '>' + safeLabel + '</option>';
    }).join("");

    select.innerHTML = html;

    if (current) {
      var found = Array.prototype.some.call(select.options, function (option) {
        return option.value === current;
      });

      if (!found) {
        select.value = "";
      }
    }
  }

  function updateDecorationMethodOptions(resetSelection) {
    var type = state.currentRfqType || "general";
    var selectedValue = resetSelection ? "" : (document.getElementById("uqm-decoration") || {}).value;

    if (type !== "stole-tassel") {
      setNoDecorationControlVisibility(false);
    }

    if (type !== "sublimated") {
      setSublimationDecorationVisibility(false);
    }

    if (type !== "promotional") {
      setPromotionalDecorationFieldsVisibility(false);
    }

    if (type === "promotional") {
      setPromotionalDecorationFieldsVisibility(true);
      return;
    }

    if (type === "stole-tassel") {
      if (isNoDecorationGraduationType()) {
        setNoDecorationControlVisibility(true);
        return;
      }

      setNoDecorationControlVisibility(false);

      if (isStoleDecorationGraduationType()) {
        renderDecorationMethodOptions(
          ["Print", "Embroidery"],
          selectedValue
        );
        return;
      }

      renderDecorationMethodOptions(
        getStoleRequestConfig().decorationMethods,
        selectedValue
      );
      return;
    }

    if (type === "sublimated") {
      setSublimationDecorationVisibility(true);
      return;
    }

    renderDecorationMethodOptions(DEFAULT_DECORATION_METHODS, selectedValue);
  }

  function renderPrintLocationOptions(options, selectedValues) {
    var grid = document.getElementById("uqm-print-locations-grid");
    if (!grid) return;

    var selectedMap = {};
    (selectedValues || []).forEach(function (value) {
      selectedMap[String(value)] = true;
    });

    grid.innerHTML = (options || []).map(function (label) {
      var safeLabel = escapeHtml(label);
      var checked = selectedMap[label] ? " checked" : "";
      return '<label><input type="checkbox" name="printLocations" value="' + safeLabel + '"' + checked + '> <span>' + safeLabel + '</span></label>';
    }).join("");
  }

  function updatePrintLocationOptions(resetSelections) {
    var fieldset = document.getElementById("uqm-print-locations-field");
    var legend = document.getElementById("uqm-print-locations-legend");
    var hint = document.getElementById("uqm-print-locations-hint");
    var type = state.currentRfqType || "general";
    var selectedValues = resetSelections ? [] : getCheckedPrintLocations();
    var stoleType = type === "stole-tassel" ? getStoleRequestType() : "";

    if (type === "promotional") {
      setPromotionalDecorationFieldsVisibility(true);

      if (hint) {
        hint.textContent = "";
      }

      return;
    }

    /*
     * Tassel-only and gown-based packages are supplied without decoration.
     * Hide and disable the entire placement field so no stale values are
     * submitted from a previously selected graduation package.
     */
    if (
      type === "stole-tassel" &&
      (
        stoleType === "Tassel Only" ||
        stoleType === "Gown Only" ||
        stoleType === "Cap + Gown Set" ||
        stoleType === "Cap + Gown + Tassel Set"
      )
    ) {
      if (fieldset) {
        fieldset.hidden = true;
        fieldset.setAttribute("aria-hidden", "true");
        fieldset.style.setProperty("display", "none", "important");
      }

      document
        .querySelectorAll('#uqm-print-locations-grid input[name="printLocations"]')
        .forEach(function (input) {
          input.checked = false;
          input.disabled = true;
        });

      if (hint) hint.textContent = "";
      return;
    }

    if (fieldset) {
      fieldset.hidden = false;
      fieldset.removeAttribute("aria-hidden");
      fieldset.style.removeProperty("display");
    }

    if (
      type === "stole-tassel" &&
      (
        stoleType === "Stole Only" ||
        stoleType === "Stole + Tassel Set" ||
        stoleType === "Full Graduation Set"
      )
    ) {
      if (legend) legend.textContent = "Decoration placement";

      if (hint) {
        hint.textContent =
          stoleType === "Stole Only"
            ? "Decoration applies to the front panels of the stole."
            : "Decoration applies to the stole only; the other package items do not have decoration placement.";
      }

      renderPrintLocationOptions(
        ["Left panel", "Right panel"],
        selectedValues
      );
      return;
    }

    var configuredOptions = configuredOptionsForField("printLocations");

    if (configuredOptions && configuredOptions.length) {
      if (legend) {
        legend.textContent =
          type === "promotional" ? "Imprint location" :
          type === "stole-tassel" ? "Decoration placement" :
          type === "sublimated" ? "Sublimation / personalization placement" :
          "Print locations";
      }

      if (hint) {
        hint.textContent = "Options are controlled by the Admin Form Manager for the current selection.";
      }

      renderPrintLocationOptions(configuredOptions, selectedValues);
      return;
    }


    if (type === "promotional") {
      var promoType = getPromotionalProductType();
      var options = getPromotionalLocationOptions(promoType);

      if (legend) legend.textContent = "Imprint location";
      if (hint) {
        hint.textContent = promoType
          ? "Options are based on the selected promotional product type."
          : "Select a promotional product type to show more specific imprint location options.";
      }

      renderPrintLocationOptions(options, selectedValues);
      return;
    }

    if (type === "stole-tassel") {
      if (legend) legend.textContent = "Decoration placement";
      if (hint) hint.textContent = "Options are based on the selected stole, tassel, gown, or graduation set.";
      renderPrintLocationOptions(getStoleRequestConfig().placements, selectedValues);
      return;
    }

    if (type === "sublimated") {
      if (legend) legend.textContent = "Sublimation / personalization placement";
      if (hint) hint.textContent = "Options are based on common sublimated uniform areas.";
      renderPrintLocationOptions(SUBLIMATED_PLACEMENT_OPTIONS, selectedValues);
      return;
    }

    if (type === "pe-uniform") {
      if (legend) legend.textContent = "PE print locations";
      if (hint) hint.textContent = "Select the areas that may require the school name, initials, logo, or PE identification.";
      renderPrintLocationOptions(PE_PRINT_LOCATION_OPTIONS, selectedValues);
      return;
    }

    if (legend) legend.textContent = "Print locations";
    if (hint) hint.textContent = "";
    renderPrintLocationOptions(DEFAULT_PRINT_LOCATIONS, selectedValues);
  }


  function updateFullPageLinkVisibility() {
    var fullPageLink = document.getElementById("uqm-full-page-link");
    if (!fullPageLink) return;

    var shouldHide =
      state.currentRfqType === "promotional" ||
      state.currentRfqType === "stole-tassel" ||
      state.currentRfqType === "sublimated" ||
      state.currentRfqType === "custom-webstore";

    fullPageLink.hidden = shouldHide;
    fullPageLink.classList.toggle("uqm__full-page-link--hidden", shouldHide);
  }

  function setRequestMode(rfqType, packageName) {
    var type = normalizeRfqType(rfqType);
    state.currentRfqType = type;

    setValue("uqm-rfq-type", type);
    setValue("uqm-package-name", packageName || "");

    document.querySelectorAll("[data-uqm-mode-section]").forEach(function (section) {
      var sectionType = section.getAttribute("data-uqm-mode-section");
      section.hidden = sectionType !== type;
    });

    var modal = getModal();
    if (modal) {
      modal.classList.toggle("uqm--custom-webstore", type === "custom-webstore");
    }

    var title = document.getElementById("uqm-title");
    if (title) title.textContent = getModeLabel(type);

    var header = document.querySelector("#unisource-quote-modal .uqm__header > p:last-child");
    if (header) {
      if (type === "promotional") {
        header.textContent = "Tell us about the promotional item, quantity, decoration, artwork, and deadline.";
      } else if (type === "stole-tassel") {
        header.textContent = "Tell us about the gown, stole, tassel, colors, personalization, quantity, and ceremony date.";
      } else if (type === "sublimated") {
        header.textContent = "Tell us about the sport, uniform type, colors, names, numbers, quantity, and deadline.";
      } else if (type === "pe-uniform") {
        header.textContent = "Tell us which PE apparel is needed, school level, colors, sizes, quantity, decoration, and deadline.";
      } else if (type === "custom-webstore") {
        header.textContent = "Tell us about your organization, store audience, products, schedule, fulfillment, fundraising, and launch needs.";
      } else {
        header.textContent = "Product information is filled automatically when available.";
      }
    }

    document.querySelectorAll("[data-uqm-package-field]").forEach(function (field) {
      field.hidden = field.getAttribute("data-uqm-package-field") !== type;
    });

    updateModeControllerVisibility();

    document.querySelectorAll("[data-uqm-catalog-product-field]").forEach(function (field) {
      field.hidden = type !== "general";
    });

    var productNameField = document.querySelector("[data-uqm-product-name-field]");
    if (productNameField) {
      productNameField.hidden = type === "custom-webstore";
    }

    var productSection = document.getElementById("uqm-product-section-title");
    if (productSection) {
      productSection.hidden = type === "custom-webstore";
    }

    var summary = document.getElementById("uqm-product-summary");
    if (summary && type !== "general") summary.hidden = true;

    var productTitle = document.getElementById("uqm-product-section-title");
    if (productTitle) {
      productTitle.textContent = type === "promotional"
        ? "Promotional item and quantity"
        : type === "stole-tassel"
          ? "Gown / stole / tassel and quantity"
          : type === "sublimated"
            ? "Sublimated apparel and quantity"
            : type === "pe-uniform"
              ? "PE apparel and quantity"
              : type === "custom-webstore"
                ? "Store requirements"
                : "Product and quantity";
    }

    var productNameLabel = document.getElementById("uqm-product-name-label");
    if (productNameLabel) {
      productNameLabel.textContent = type === "promotional"
        ? "Item / package name"
        : type === "stole-tassel"
          ? "Gown / stole / tassel package name"
          : type === "sublimated"
            ? "Sublimated apparel package name"
            : type === "pe-uniform"
              ? "PE program / package name"
              : type === "custom-webstore"
                ? "Online store project name"
                : "Product name";
    }

    var neededByLabel = document.getElementById("uqm-needed-by-label");
    if (neededByLabel) {
      neededByLabel.textContent = type === "stole-tassel"
        ? "Ceremony / deadline date"
        : "Needed-by date";
    }

    document.querySelectorAll("[data-uqm-standard-quantity-field]").forEach(function (field) {
      field.hidden = type === "custom-webstore";

      field.querySelectorAll("input, select, textarea").forEach(function (input) {
        input.disabled = type === "custom-webstore";

        if (type === "custom-webstore" && input.id === "uqm-quantity") {
          input.required = false;
          input.value = "";
        }
      });
    });

    if (type !== "custom-webstore") {
      var quantityInput = document.getElementById("uqm-quantity");
      if (quantityInput) {
        quantityInput.disabled = false;
        quantityInput.required = true;
      }
    }

    var productName = document.getElementById("uqm-product-name");
    if (productName && !productName.value && packageName) {
      productName.value = packageName;
    }

    var decorationHeading = document.querySelector(
      "#unisource-quote-modal .uqm__section--first > h3"
    );

    if (decorationHeading) {
      decorationHeading.textContent =
        type === "custom-webstore"
          ? "Branding and store setup"
          : "Decoration and artwork";
    }

    var isCustomWebstore = type === "custom-webstore";
    setFieldVisibilityById("uqm-decoration", !isCustomWebstore);
    setFieldVisibilityById("uqm-artwork-status", true);

    var printLocationsField = document.getElementById("uqm-print-locations-field");
    if (printLocationsField) {
      printLocationsField.hidden = isCustomWebstore;
      printLocationsField.querySelectorAll("input").forEach(function (input) {
        input.disabled = isCustomWebstore;
        if (isCustomWebstore) input.checked = false;
      });
    }

    updateFullPageLinkVisibility();
    applyConfiguredContent();
    updateDecorationMethodOptions(true);
    applyConfiguredChoiceOptions();
    updatePrintLocationOptions(true);

    setPromotionalDecorationFieldsVisibility(
      state.currentRfqType === "promotional"
    );
    applyConfiguredFieldRules();
    updateProjectNotesRequirement();
  }

function fillProductContext(context) {
    var data = normalizeContext(context);
    state.triggerContext = data;

    setRequestMode(data.rfqType, data.packageName);

    /*
    * Keep technical identifiers stored in hidden fields.
    * Do not show Product ID or Style ID in the customer/sales-facing modal.
    */
    setValue("uqm-product-id", data.productId);
    setValue("uqm-product-name", data.productName);
    setValue("uqm-manufacturer-sku", data.manufacturerSku);
    setValue("uqm-style-id", data.selectedStyleId);
    setValue("uqm-color", data.selectedColor);
    setValue("uqm-quantity", data.quantity > 0 ? data.quantity : 1);
    setValue("uqm-product-image-url", data.productImageUrl);
    setValue("uqm-source-page-url", data.sourcePageUrl);

    var summary = document.getElementById("uqm-product-summary");
    var image = document.getElementById("uqm-product-image");
    var name = document.getElementById("uqm-product-summary-name");
    var meta = document.getElementById("uqm-product-summary-meta");

    var hasProduct =
      !!data.productName ||
      !!data.manufacturerSku ||
      !!data.selectedColor ||
      !!data.productImageUrl;

    if (summary) {
      summary.hidden = state.currentRfqType !== "general" || !hasProduct;
    }

    if (name) {
      name.textContent = data.productName || "Selected product";
    }

    var metaParts = [];

    if (data.manufacturerSku) {
      metaParts.push("SKU: " + data.manufacturerSku);
    }

    if (data.selectedColor) {
      metaParts.push("Color: " + data.selectedColor);
    }

    if (meta) {
      meta.textContent = metaParts.join(" • ");
    }

    if (image) {
      if (data.productImageUrl) {
        image.src = data.productImageUrl;
        image.alt = data.productName || "Selected product";
        image.hidden = false;
      } else {
        image.removeAttribute("src");
        image.hidden = true;
      }
    }

    var fullPageLink = document.getElementById("uqm-full-page-link");
    if (fullPageLink) {
      fullPageLink.href = buildFullPageUrl(data);
      updateFullPageLinkVisibility();
    }
  }

  function showAlert(message, type) {
    var el = document.getElementById("uqm-alert");
    if (!el) return;

    if (!message) {
      el.hidden = true;
      el.textContent = "";
      el.className = "uqm__alert";
      return;
    }

    el.hidden = false;
    el.textContent = message;
    el.className = "uqm__alert" + (type ? " is-" + type : "");
  }

  function getFieldWrapper(field) {
    if (!field || !field.closest) return null;
    return field.closest(".uqm__field, .uqm__consent, fieldset");
  }

  function getFieldByName(name) {
    var form = getForm();
    if (!form || !name) return null;

    var field = form.elements[name];
    if (field && field.length && !field.tagName) field = field[0];

    if (!field || !field.setAttribute) {
      field = form.querySelector('[name="' + String(name).replace(/"/g, '\"') + '"]');
    }

    return field || null;
  }

  function normalizeServerFieldName(name) {
    var key = String(name || "").trim();
    var map = {
      customerName: "name",
      fullName: "name",
      schoolName: "organization",
      company: "organization",
      organizationName: "organization",
      emailAddress: "email",
      customerEmail: "email",
      phoneNumber: "phone",
      customerPhone: "phone",
      mobile: "phone",
      telephone: "phone",
      estimatedQuantity: "quantity",
      qty: "quantity",
      productInquiry: "productName",
      inquiry: "productName",
      productOrInquiry: "productName",
      decorationStatus: "artworkStatus",
      decorationPlacement: "printLocations",
      placement: "printLocations",
      placements: "printLocations",
      projectNotes: "notes",
      message: "notes",
      preferred_contact_method: "preferredContactMethod",
      artwork_status: "artworkStatus",
      print_locations: "printLocations",
      rfq_type: "rfqType",
      stole_type: "stoleType",
      promotional_product_type: "promotionalProductType"
    };

    return map[key] || key;
  }

  function clearErrors() {
    document.querySelectorAll("[data-uqm-error]").forEach(function (el) {
      el.textContent = "";
    });

    var form = getForm();
    if (!form) return;

    form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
      el.setAttribute("aria-invalid", "false");
    });

    form.querySelectorAll(".is-invalid").forEach(function (el) {
      el.classList.remove("is-invalid");
    });
  }

  function setError(name, message) {
    var form = getForm();
    if (!form) return;

    var normalizedName = normalizeServerFieldName(name);
    var field = getFieldByName(normalizedName);
    var fieldForError = normalizedName;

    if (!field && normalizedName === "printLocations") {
      field = form.querySelector('input[name="printLocations"]');
    }

    if (field && field.setAttribute) {
      field.setAttribute("aria-invalid", message ? "true" : "false");

      var wrapper = getFieldWrapper(field);
      if (wrapper) wrapper.classList.toggle("is-invalid", !!message);
    }

    var error = document.querySelector('[data-uqm-error="' + fieldForError + '"]');

    if (!error && field && field.closest) {
      var wrapperEl = getFieldWrapper(field);
      error = wrapperEl ? wrapperEl.querySelector("[data-uqm-error]") : null;
    }

    if (error) error.textContent = message || "";
  }

  function extractValidationErrors(result) {
    var raw = result && (
      result.fields ||
      result.validationErrors ||
      result.errors ||
      result.fieldErrors ||
      result.details ||
      result.errorDetails
    );

    var normalized = [];

    function add(field, message) {
      if (!field) return;
      normalized.push({
        field: normalizeServerFieldName(field),
        message: String(message || "Please review this field.")
      });
    }

    if (Array.isArray(raw)) {
      raw.forEach(function (item) {
        if (typeof item === "string") {
          add("notes", item);
          return;
        }

        if (item && typeof item === "object") {
          add(
            item.field || item.path || item.name || item.param || item.property,
            item.message || item.error || item.msg || item.reason
          );
        }
      });
    } else if (raw && typeof raw === "object") {
      Object.keys(raw).forEach(function (field) {
        var value = raw[field];
        add(field, Array.isArray(value) ? value.join(" ") : value);
      });
    }

    return normalized;
  }

  function applyServerValidationErrors(result) {
    var errors = extractValidationErrors(result);

    errors.forEach(function (item) {
      setError(item.field, item.message);
    });

    var form = getForm();
    var firstInvalid = form ? form.querySelector('[aria-invalid="true"]') : null;

    if (firstInvalid) {
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    return errors.length > 0;
  }

  function setLoading(isLoading) {
    var button = document.getElementById("uqm-submit");
    if (!button) return;

    button.disabled = isLoading;
    button.classList.toggle("is-loading", isLoading);

    var label = button.querySelector("[data-uqm-submit-label]");
    if (label) {
      label.textContent = isLoading
        ? "Submitting..."
        : "Submit Quote Request";
    }
  }

  function getArtworkFilesInfo() {
    var input = document.getElementById("uqm-artwork-files");
    if (!input || !input.files || !input.files.length) return [];

    return Array.prototype.map.call(input.files, function (file) {
      return {
        name: file.name,
        size: file.size,
        type: file.type || ""
      };
    });
  }

  function validateArtworkFiles(files) {
    var items = Array.isArray(files) ? files : [];
    var allowed = /\.(ai|eps|pdf|svg|png|jpe?g|webp|psd|tiff?)$/i;
    var total = 0;

    if (items.length > 10) {
      setError("artworkFiles", "Upload no more than 10 files.");
      return false;
    }

    for (var i = 0; i < items.length; i += 1) {
      var file = items[i];
      total += Number(file.size || 0);

      if (!allowed.test(String(file.name || ""))) {
        setError("artworkFiles", "Unsupported file type: " + file.name);
        return false;
      }

      if (Number(file.size || 0) <= 0) {
        setError("artworkFiles", "The selected file is empty: " + file.name);
        return false;
      }

      if (Number(file.size || 0) > 15 * 1024 * 1024) {
        setError("artworkFiles", "Each file must not exceed 15 MB: " + file.name);
        return false;
      }
    }

    if (total > 50 * 1024 * 1024) {
      setError("artworkFiles", "The combined attachment size must not exceed 50 MB.");
      return false;
    }

    return true;
  }

  function buildMultipartSubmission(payload) {
    var body = new FormData();
    var fileInput = document.getElementById("uqm-artwork-files");

    body.append("payload", JSON.stringify(payload));

    if (fileInput && fileInput.files) {
      Array.prototype.forEach.call(fileInput.files, function (file) {
        body.append("artworkFiles", file, file.name);
      });
    }

    return body;
  }

  function getCheckedPeApparel() {
    var form = getForm();
    if (!form) return [];

    return Array.prototype.slice
      .call(form.querySelectorAll('input[name="peApparel"]:checked'))
      .map(function (input) {
        return String(input.value || "").trim();
      })
      .filter(Boolean);
  }

  function getCheckedWebstoreProducts() {
    var form = getForm();
    if (!form) return [];

    return Array.prototype.slice
      .call(form.querySelectorAll('input[name="webstoreProducts"]:checked'))
      .map(function (input) {
        return String(input.value || "").trim();
      })
      .filter(Boolean);
  }

  function applyPePackageSelection() {
    var select = document.getElementById("uqm-pe-package-type");
    var form = getForm();
    if (!select || !form) return;

    var value = String(select.value || "").trim();
    var mapping = {
      "T-shirt only": ["T-shirt"],
      "Shorts only": ["Shorts"],
      "T-shirt + shorts": ["T-shirt", "Shorts"],
      "Sweatshirt + sweatpants": ["Sweatshirt", "Sweatpants"],
      "Complete PE package": ["T-shirt", "Shorts", "Sweatshirt", "Sweatpants"]
    };

    if (!mapping[value]) return;

    form.querySelectorAll('input[name="peApparel"]').forEach(function (input) {
      input.checked = mapping[value].indexOf(input.value) >= 0;
    });
  }

  function collectPayload() {
    var form = getForm();
    var data = new FormData(form);
    var selectedStoleType =
      String(data.get("stoleType") || getStoleRequestType() || "").trim();
    var noDecorationGraduation =
      state.currentRfqType === "stole-tassel" &&
      (
        selectedStoleType === "Tassel Only" ||
        selectedStoleType === "Gown Only" ||
        selectedStoleType === "Cap + Gown Set" ||
        selectedStoleType === "Cap + Gown + Tassel Set"
      );
    var submittedDecorationMethod =
      state.currentRfqType === "custom-webstore"
        ? ""
        : state.currentRfqType === "sublimated"
          ? "Sublimation"
          : state.currentRfqType === "promotional"
            ? ""
            : noDecorationGraduation
            ? "No decoration needed"
            : String(
                data.get("decorationMethod") || ""
              ).trim();

    var submittedPrintLocations =
      state.currentRfqType === "custom-webstore"
        ? []
        : state.currentRfqType === "promotional"
          ? []
          : noDecorationGraduation
          ? ["No location needed"]
          : getCheckedPrintLocations();

    return {
      formType: "request-quote",
      rfqType: state.currentRfqType || "general",
      name: String(data.get("name") || "").trim(),
      organization: String(data.get("organization") || "").trim(),
      email: String(data.get("email") || "").trim(),
      phone: String(data.get("phone") || "").trim(),
      preferredContactMethod: String(data.get("preferredContactMethod") || "email"),
      quantity: Number(
        data.get("quantity") ||
        (
          state.currentRfqType === "custom-webstore"
            ? 1
            : state.currentRfqType === "stole-tassel" &&
              selectedStoleType === "Tassel Only"
              ? 1
              : 0
        )
      ),
      neededByDate: String(data.get("neededByDate") || "").trim(),
      decorationMethod: submittedDecorationMethod,
      printLocations: submittedPrintLocations,
      artworkStatus: normalizeArtworkStatusForBackend(String(data.get("artworkStatus") || "").trim()),
      artworkStatusCode: String(data.get("artworkStatus") || "").trim(),
      artworkStatusLabel: getArtworkStatusLabel(String(data.get("artworkStatus") || "").trim()),
      artworkFiles: getArtworkFilesInfo(),
      notes: String(data.get("notes") || "").trim(),
      projectNotes: String(data.get("notes") || "").trim(),
      consent: data.get("consent") === "on",
      productId: String(data.get("productId") || "").trim(),
      productName: String(data.get("productName") || "").trim(),
      manufacturerSku: String(data.get("manufacturerSku") || "").trim(),
      selectedStyleId: String(data.get("selectedStyleId") || "").trim(),
      selectedColor: String(data.get("selectedColor") || "").trim(),
      productImageUrl: String(data.get("productImageUrl") || "").trim(),
      sourcePageUrl: String(data.get("sourcePageUrl") || window.location.href).trim(),
      packageName: String(data.get("packageName") || "").trim(),

      promotionalProductType: String(data.get("promotionalProductType") || "").trim(),
      promotionalImprintColors:
        state.currentRfqType === "promotional"
          ? ""
          : String(
              data.get("promotionalImprintColors") || ""
            ).trim(),
      promotionalImprintLocation: "",

      stoleSchool: String(data.get("stoleSchool") || "").trim(),
      yearCharm: data.get("yearCharm") === "true" || data.get("yearCharm") === "on",
      stoleGraduationYear: String(data.get("stoleGraduationYear") || "").trim(),
      stoleType: selectedStoleType,
      stoleColor: String(data.get("stoleColor") || "").trim(),
      tasselColor: String(data.get("tasselColor") || "").trim(),
      tasselSecondaryColor: String(data.get("tasselSecondaryColor") || "").trim(),
      gownColor: String(data.get("gownColor") || "").trim(),
      gownSizeRange: String(data.get("gownSizeRange") || "").trim(),
      stolePersonalization: String(data.get("stolePersonalization") || "").trim(),
      stoleDecorationType: noDecorationGraduation
        ? "No decoration needed"
        : String(
            data.get("stoleDecorationType") ||
            data.get("decorationMethod") ||
            ""
          ).trim(),
      stoleDeadlineDate: String(data.get("stoleDeadlineDate") || "").trim(),

      sublimatedGarmentType: String(data.get("sublimatedGarmentType") || "").trim(),
      sublimatedTeamName: String(data.get("sublimatedTeamName") || "").trim(),
      sublimatedSeason: String(data.get("sublimatedSeason") || "").trim(),
      sublimatedSport: String(data.get("sublimatedSport") || "").trim(),
      sublimatedUniformSet: String(data.get("sublimatedUniformSet") || "").trim(),
      sublimatedPrimaryColor: String(data.get("sublimatedPrimaryColor") || "").trim(),
      sublimatedSecondaryColor: String(data.get("sublimatedSecondaryColor") || "").trim(),
      sublimatedSizeRange: String(data.get("sublimatedSizeRange") || "").trim(),
      sublimatedPersonalization: String(data.get("sublimatedPersonalization") || "").trim(),
      sublimatedDesignNotes: String(data.get("sublimatedDesignNotes") || "").trim(),
      sublimatedDecorationType: String(data.get("decorationMethod") || "").trim(),
      sublimatedPlacement: getCheckedPrintLocations().join(", "),

      pePackageType: String(data.get("pePackageType") || "").trim(),
      peStudentLevel: String(data.get("peStudentLevel") || "").trim(),
      peApparel: getCheckedPeApparel(),
      pePrimaryColor: String(data.get("pePrimaryColor") || "").trim(),
      peSecondaryColor: String(data.get("peSecondaryColor") || "").trim(),
      peSizeRange: String(data.get("peSizeRange") || "").trim(),
      pePrintColors: String(data.get("pePrintColors") || "").trim(),
      peSchoolMarking: String(data.get("peSchoolMarking") || "").trim(),
      pePrintLocations:
        state.currentRfqType === "pe-uniform"
          ? getCheckedPrintLocations()
          : [],

      webstoreOrganizationType: String(data.get("webstoreOrganizationType") || "").trim(),
      webstoreName: String(data.get("webstoreName") || "").trim(),
      webstoreType: String(data.get("webstoreType") || "").trim(),
      webstoreParticipants: Number(data.get("webstoreParticipants") || 0),
      webstoreProducts: getCheckedWebstoreProducts(),
      webstoreStyleCount: String(data.get("webstoreStyleCount") || "").trim(),
      webstoreSchedule: String(data.get("webstoreSchedule") || "").trim(),
      webstoreOpenDate: String(data.get("webstoreOpenDate") || data.get("webstoreCloseDate") || "").trim(),
      webstoreFulfillment: String(data.get("webstoreFulfillment") || "").trim(),
      webstoreFundraising: String(data.get("webstoreFundraising") || "").trim(),
      webstoreMarkup: String(data.get("webstoreMarkup") || "").trim(),
      webstoreTaxStatus: String(data.get("webstoreTaxStatus") || "").trim(),
      webstoreApprover: String(data.get("webstoreApprover") || "").trim(),
      webstoreReportRecipient: String(data.get("webstoreReportRecipient") || "").trim(),
      webstorePromotionHelp: String(data.get("webstorePromotionHelp") || "").trim(),

      companyWebsite: String(data.get("companyWebsite") || "").trim()
    };
  }

  function getArtworkStatusLabel(value) {
    var key = String(value || "").trim();
    var labels = {
      "artwork-ready": "I have artwork ready",
      "reference-only": "I have a reference only",
      "needs-design-help": "I need design help",
      "updating-existing-artwork": "Updating existing artwork",
      "not-sure": "Not sure yet"
    };

    return labels[key] || key;
  }

  function normalizeArtworkStatusForBackend(value) {
    var key = String(value || "").trim();
    var backendValues = {
      "artwork-ready": "ready",
      "reference-only": "needs-review",
      "needs-design-help": "needs-design-help",
      "updating-existing-artwork": "needs-review",
      "not-sure": "not-sure"
    };

    return backendValues[key] || key;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }

  function validate(payload) {
    clearErrors();

    var valid = true;

    if (!payload.name || payload.name.length < 2) {
      setError("name", "Please enter your name.");
      valid = false;
    }

    if (!payload.organization || payload.organization.length < 2) {
      setError("organization", "Please enter your school, organization, or company.");
      valid = false;
    }

    if (!payload.email) {
      setError("email", "Please enter your email address.");
      valid = false;
    } else if (!isValidEmail(payload.email)) {
      setError("email", "Please enter a valid email address.");
      valid = false;
    }

    if (!payload.phone) {
      setError("phone", "Please enter your phone number.");
      valid = false;
    }

    if (!Number.isInteger(payload.quantity) || payload.quantity < 1) {
      setError("quantity", "Please enter a quantity of at least 1.");
      valid = false;
    }

    if (!payload.artworkStatus) {
      setError("artworkStatus", "Please select the artwork status.");
      valid = false;
    }

    if (!validateArtworkFiles(payload.artworkFiles)) {
      valid = false;
    }

    if (payload.rfqType === "promotional" && !payload.promotionalProductType) {
      setError("promotionalProductType", "Please select the promotional product type.");
      valid = false;
    }

    if (payload.rfqType === "stole-tassel" && !payload.stoleType) {
      setError("stoleType", "Please select the stole type.");
      valid = false;
    }

    if (
      payload.rfqType === "stole-tassel" &&
      payload.stoleType === "Tassel Only" &&
      !payload.tasselColor
    ) {
      setError("tasselColor", "Please select the primary tassel color.");
      valid = false;
    }

    if (
      payload.rfqType === "stole-tassel" &&
      payload.stoleType === "Tassel Only" &&
      payload.yearCharm
    ) {
      if (!payload.stoleGraduationYear) {
        setError(
          "stoleGraduationYear",
          "Please enter the graduation year for the Year Charm."
        );
        valid = false;
      } else if (!/^\d{4}$/.test(payload.stoleGraduationYear)) {
        setError(
          "stoleGraduationYear",
          "Enter a four-digit graduation year."
        );
        valid = false;
      }
    }

    if (payload.rfqType === "sublimated" && !payload.sublimatedGarmentType) {
      setError("sublimatedGarmentType", "Please select the sublimated apparel type.");
      valid = false;
    }

    if (payload.rfqType === "pe-uniform" && !payload.pePackageType) {
      setError("pePackageType", "Please select the PE package type.");
      valid = false;
    }

    if (
      payload.rfqType === "pe-uniform" &&
      (!Array.isArray(payload.peApparel) || payload.peApparel.length === 0)
    ) {
      setError("peApparel", "Please select at least one PE apparel item.");
      valid = false;
    }

    if (
      payload.rfqType === "custom-webstore" &&
      !payload.webstoreOrganizationType
    ) {
      setError("webstoreOrganizationType", "Please select the organization type.");
      valid = false;
    }

    if (
      payload.rfqType === "custom-webstore" &&
      !payload.webstoreType
    ) {
      setError("webstoreType", "Please select the online store type.");
      valid = false;
    }

    if (
      payload.rfqType === "custom-webstore" &&
      !payload.webstoreSchedule
    ) {
      setError("webstoreSchedule", "Please select the store schedule.");
      valid = false;
    }

    if (
      payload.rfqType === "custom-webstore" &&
      !payload.webstoreFulfillment
    ) {
      setError("webstoreFulfillment", "Please select a fulfillment method.");
      valid = false;
    }

    if (!payload.consent) {
      setError("consent", "Please confirm your consent.");
      valid = false;
    }

    return valid;
  }

  function resetForm(keepProductContext) {
    var form = getForm();
    if (!form) return;

    state.submitting = false;
    form.dataset.submitting = "false";
    setLoading(false);

    form.reset();
    clearErrors();
    showAlert("");

    var success = document.getElementById("uqm-success");
    if (success) {
      success.hidden = true;
      success.style.display = "none";
      success.classList.remove("is-visible");
    }

    form.hidden = false;
    form.style.display = "";

    var count = document.getElementById("uqm-notes-count");
    if (count) count.textContent = "0";

    if (keepProductContext) fillProductContext(state.triggerContext);
  }

  function open(context) {
    var modal = getModal();
    if (!modal) return;

    resetForm(false);
    fillProductContext(context || {});

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("uqm-open");

    window.setTimeout(function () {
      var first = document.getElementById("uqm-name");
      if (first) first.focus();
    }, 50);
  }

  function close() {
    var modal = getModal();
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("uqm-open");
  }

  function getInksoftProductPageContext() {
    try {
      var productPage =
        window.InksoftPOC &&
        window.InksoftPOC.productPage;

      if (!productPage) {
        return normalizeContext({});
      }

      /*
       * The InkSoft product module already builds an authoritative quote URL
       * containing the current product, selected style/color, image, quantity,
       * and source page. Reuse that URL rather than trying to scrape the page.
       */
      if (typeof productPage.buildRequestQuoteUrl === "function") {
        var quoteUrl = productPage.buildRequestQuoteUrl();

        if (quoteUrl) {
          var parsedContext = parseQuoteUrl(quoteUrl);

          if (
            parsedContext.productId ||
            parsedContext.productName ||
            parsedContext.productImageUrl
          ) {
            return parsedContext;
          }
        }
      }

      /*
       * Secondary fallback for older product-page builds.
       */
      if (typeof productPage.getState === "function") {
        var productState = productPage.getState() || {};
        var product = productState.product || {};
        var currentStyle = null;
        var styles = [];

        styles = styles
          .concat(Array.isArray(product.styles) ? product.styles : [])
          .concat(Array.isArray(product.Styles) ? product.Styles : [])
          .concat(Array.isArray(product.baseStyles) ? product.baseStyles : [])
          .concat(Array.isArray(product.BaseStyles) ? product.BaseStyles : []);

        var selectedStyleId = String(
          productState.currentStyleId ||
          (
            typeof productPage.getCurrentStyleId === "function"
              ? productPage.getCurrentStyleId()
              : ""
          ) ||
          ""
        );

        for (var i = 0; i < styles.length; i += 1) {
          var style = styles[i] || {};
          var styleId = String(
            style.id ||
            style.ID ||
            style.Id ||
            style.styleId ||
            style.StyleId ||
            style.productStyleId ||
            style.ProductStyleId ||
            ""
          );

          if (styleId && styleId === selectedStyleId) {
            currentStyle = style;
            break;
          }
        }

        if (!currentStyle && styles.length) {
          currentStyle = styles[0];
        }

        var currentImages = Array.isArray(productState.currentImages)
          ? productState.currentImages
          : [];

        var imageIndex = Number(productState.currentImageIndex || 0);
        var currentImage = currentImages[imageIndex] || currentImages[0] || {};

        var quantityInput = document.getElementById("inksoft-quote-qty");
        var quantity = quantityInput
          ? Number(quantityInput.value || 1)
          : 1;

        return normalizeContext({
          productId:
            product.id ||
            product.ID ||
            product.Id ||
            product.productId ||
            product.ProductId ||
            "",
          productName:
            product.name ||
            product.Name ||
            "",
          manufacturerSku:
            product.manufacturerSku ||
            product.manufacturerSKU ||
            product.ManufacturerSku ||
            product.ManufacturerSKU ||
            product.manufacturerStyleCode ||
            product.ManufacturerStyleCode ||
            product.sku ||
            product.Sku ||
            "",
          selectedStyleId: selectedStyleId,
          selectedColor:
            currentStyle &&
            (
              currentStyle.name ||
              currentStyle.Name ||
              currentStyle.colorName ||
              currentStyle.ColorName ||
              currentStyle.displayName ||
              currentStyle.DisplayName
            ) ||
            "",
          productImageUrl:
            currentImage.imageUrl ||
            currentImage.thumbnailUrl ||
            product.imageUrl ||
            product.ImageUrl ||
            product.thumbnailUrl ||
            product.ThumbnailUrl ||
            "",
          sourcePageUrl: window.location.href,
          quantity:
            Number.isFinite(quantity) && quantity > 0
              ? Math.floor(quantity)
              : 1
        });
      }
    } catch (error) {
      console.warn(
        "[Unisource Quote Modal] Could not read InkSoft product context:",
        error
      );
    }

    return normalizeContext({});
  }

  function getTriggerContext(trigger) {
    var dataset = trigger.dataset || {};

    var direct = normalizeContext({
      productId: dataset.quoteProductId || dataset.productId,
      productName: dataset.quoteProductName || dataset.productName,
      manufacturerSku: dataset.quoteManufacturerSku || dataset.manufacturerSku || dataset.sku,
      selectedStyleId: dataset.quoteSelectedStyleId || dataset.quoteStyleId || dataset.selectedStyleId || dataset.styleId,
      selectedColor: dataset.quoteSelectedColor || dataset.quoteColor || dataset.selectedColor || dataset.color,
      productImageUrl: dataset.quoteProductImage || dataset.quoteProductImageUrl || dataset.productImageUrl || dataset.imageUrl,
      sourcePageUrl: dataset.quoteSourcePageUrl || dataset.sourcePageUrl || window.location.href,
      quantity: dataset.quoteQuantity || dataset.quantity || 1,
      rfqType: dataset.rfqType || dataset.quoteRfqType || dataset.quoteType,
      packageName: dataset.rfqPackage || dataset.packageName || dataset.quotePackageName
    });

    if (
      direct.productId ||
      direct.productName ||
      direct.productImageUrl ||
      direct.rfqType !== "general" ||
      direct.packageName
    ) {
      return direct;
    }

    var href = trigger.getAttribute("href") || "";
    if (href) {
      var hrefContext = parseQuoteUrl(href);

      if (
        hrefContext.productId ||
        hrefContext.productName ||
        hrefContext.productImageUrl ||
        hrefContext.rfqType !== "general" ||
        hrefContext.packageName
      ) {
        return hrefContext;
      }
    }

    /*
     * The InkSoft product-page Request a Quote control is a button, not a
     * populated link. Pull its current product context from productPage.
     */
    if (
      trigger.id === "inksoft-btn-request-quote" ||
      document.getElementById("inksoft-product-root")
    ) {
      var inksoftContext = getInksoftProductPageContext();

      if (
        inksoftContext.productId ||
        inksoftContext.productName ||
        inksoftContext.productImageUrl
      ) {
        return inksoftContext;
      }
    }

    return direct;
  }

  function looksLikeQuoteTrigger(trigger) {
    if (!trigger) return false;

    if (
      trigger.hasAttribute("data-unisource-quote") ||
      trigger.hasAttribute("data-unisource-quote-open") ||
      trigger.hasAttribute("data-quote-modal")
    ) {
      return true;
    }

    var href = trigger.getAttribute("href") || "";
    if (href) {
      try {
        var parsed = new URL(href, window.location.origin);
        if (parsed.pathname === "/pages/request-a-quote") return true;
      } catch (error) {
        if (href.indexOf("/pages/request-a-quote") >= 0) return true;
      }
    }

    var text = String(trigger.textContent || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    return text === "request a quote";
  }

  function bindCustomQuoteEvents() {
    document.addEventListener("unisource:open-quote", function (event) {
      var detail = event.detail || {};

      open(
        normalizeContext({
          productId: detail.productId,
          productName: detail.productName,
          manufacturerSku: detail.manufacturerSku,
          selectedStyleId: detail.selectedStyleId || detail.styleId,
          selectedColor: detail.selectedColor || detail.color,
          productImageUrl: detail.productImageUrl || detail.imageUrl,
          sourcePageUrl: detail.sourcePageUrl || window.location.href,
          quantity: detail.quantity || 1,
          rfqType: detail.rfqType || detail.rfq_type,
          packageName: detail.packageName || detail.package
        })
      );
    });
  }

  function bindTriggers() {
    document.addEventListener(
      "click",
      function (event) {
        var trigger = event.target.closest("a, button, [role='button']");
        if (!trigger) return;

        /*
         * Let the dedicated fallback link inside the modal navigate normally
         * to the standalone Request a Quote page.
         */
        if (trigger.hasAttribute("data-uqm-full-page")) {
          return;
        }

        if (!looksLikeQuoteTrigger(trigger)) return;

        if (
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        open(getTriggerContext(trigger));
      },
      true
    );
  }

  function bindCloseButtons() {
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-uqm-close]")) close();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") close();
    });
  }

  function bindDynamicStoleFields() {
    document.addEventListener("change", function (event) {
      if (!event.target) return;

      if (event.target.id === "uqm-year-charm") {
        updateYearCharmRequirement();
        return;
      }

      if (event.target.id !== "uqm-stole-type") {
        return;
      }

      var stoleSelect = event.target;
      var selectedValue = String(stoleSelect.value || "").trim();

      /* Keep the controller stable; never rebuild it in this change cycle. */
      updateModeControllerVisibility();

      /* First apply the hard visibility matrix for the selected package. */
      updateStoleDynamicFields();

      /* Then resolve Admin-managed conditional options against that value. */
      updateDecorationMethodOptions(true);
      applyConfiguredChoiceOptions();
      updatePrintLocationOptions(true);
      updateProjectNotesRequirement();
      applyConfiguredFieldRules();

      /* Config rules may touch the same wrappers; the package matrix wins last. */
      updateStoleDynamicFields();
      updateModeControllerVisibility();
      updateYearCharmRequirement();

      if (selectedValue && stoleSelect.value !== selectedValue) {
        stoleSelect.value = selectedValue;
      }
    });
  }

  function bindDynamicPromotionalLocations() {
    document.addEventListener("change", function (event) {
      if (!event.target || event.target.id !== "uqm-promo-product-type") return;
      updatePrintLocationOptions(true);
      updateDecorationMethodOptions(true);
      updateProjectNotesRequirement();
      applyConfiguredChoiceOptions();
      applyConfiguredFieldRules();
      updateModeControllerVisibility();
    });

    document.addEventListener("change", function (event) {
      if (!event.target || event.target.id !== "uqm-sublimated-garment-type") return;
      updatePrintLocationOptions(true);
      updateDecorationMethodOptions(true);
      updateProjectNotesRequirement();
      applyConfiguredChoiceOptions();
      applyConfiguredFieldRules();
      updateModeControllerVisibility();
    });
  }

  function bindForm() {
    var form = getForm();
    if (!form) return;

    if (form.dataset.uqmSubmitBound === "true") {
      return;
    }

    form.dataset.uqmSubmitBound = "true";

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (state.submitting === true || form.dataset.submitting === "true") {
        console.warn("[Unisource Quote Modal] Duplicate submit blocked.");
        return;
      }

      showAlert("");

      var payload = collectPayload();

      if (!validate(payload)) {
        showAlert("Please review the highlighted fields.", "error");

        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      state.submitting = true;
      form.dataset.submitting = "true";
      setLoading(true);

      try {
        var response = await fetch(API_URL, {
          method: "POST",
          cache: "no-store",
          headers: {
            Accept: "application/json"
          },
          body: buildMultipartSubmission(payload)
        });

        var text = await response.text();
        var result = {};

        try {
          result = text ? JSON.parse(text) : {};
        } catch (error) {
          throw new Error("The server returned an invalid response.");
        }

        var successReference =
          result.submissionId ||
          result.reference ||
          result.referenceNumber ||
          result.id ||
          "";

        /*
         * Some Azure validation responses can still include a saved RFQ reference.
         * If a reference exists, treat it as a successful submission so the user
         * does not see a false validation error after the admin record is created.
         */
        if (!response.ok || result.success !== true) {
          if (!successReference) {
            var hasFieldErrors = applyServerValidationErrors(result);

            throw new Error(
              hasFieldErrors
                ? "Please review the highlighted fields."
                : (
                    result.error ||
                    result.message ||
                    "We could not submit your quote request."
                  )
            );
          }
        }

        successReference = successReference || "RECEIVED";

        form.hidden = true;
        form.style.display = "none";

        /*
         * Success confirmation is rendered into the alert area above the form.
         * This is more reliable across Shopify theme CSS because the alert area
         * is already visible inside the modal header/body flow.
         */
        var alertBox = document.getElementById("uqm-alert");
        if (alertBox) {
          alertBox.hidden = false;
          alertBox.className = "uqm__alert is-success uqm__success-inline";
          alertBox.innerHTML =
            '<div class="uqm__success-icon">✓</div>' +
            '<p class="uqm__eyebrow">Quote request received</p>' +
            '<h3>Thank you. We have received your request.</h3>' +
            '<p>Our team will review the details and follow up with you.</p>' +
            '<div class="uqm__reference"><span>Reference number</span><strong>' +
            escapeHtml(successReference) +
            '</strong></div>' +
            '<div class="uqm__success-actions">' +
            '<button type="button" id="uqm-another">Submit another request</button>' +
            '<button type="button" data-uqm-close>Close</button>' +
            '</div>';
        }

        var reference = document.getElementById("uqm-reference");
        if (reference) {
          reference.textContent = successReference;
        }

        var success = document.getElementById("uqm-success");
        if (success) {
          success.hidden = true;
          success.style.display = "none";
          success.classList.remove("is-visible");
        }

        window.setTimeout(function () {
          var target = document.getElementById("uqm-alert");
          if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 50);

        /*
         * Important:
         * Do not unlock submit after success. The form is hidden already.
         * Unlocking here can allow a second submit race in slow browsers.
         */
      } catch (error) {
        console.error("[Unisource Quote Modal]", error);

        showAlert(
          error && error.message
            ? error.message
            : "We could not submit your quote request.",
          "error"
        );

        state.submitting = false;
        form.dataset.submitting = "false";
        setLoading(false);
      }
    });

    var notes = document.getElementById("uqm-notes");
    var notesCount = document.getElementById("uqm-notes-count");

    if (notes && notesCount && notes.dataset.uqmNotesBound !== "true") {
      notes.dataset.uqmNotesBound = "true";
      notes.addEventListener("input", function () {
        notesCount.textContent = String(notes.value.length);
        if (notes.value.trim().length > 0) {
          setError("notes", "");
        }
      });
    }

    if (form.dataset.uqmInputBound !== "true") {
      form.dataset.uqmInputBound = "true";

      form.addEventListener("input", function (event) {
        var field = event.target;
        if (field && field.name) setError(field.name, "");
      });

      form.addEventListener("change", function (event) {
        var field = event.target;
        if (field && field.name) setError(field.name, "");
      });
    }

    if (document.documentElement.dataset.uqmAnotherBound !== "true") {
      document.documentElement.dataset.uqmAnotherBound = "true";
      document.addEventListener("click", function (event) {
        if (event.target.closest("#uqm-another")) resetForm(true);
      });
    }
  }

  function init() {
    if (state.initialized) return;
    state.initialized = true;
    document.body.insertAdjacentHTML("beforeend", buildModalHtml());

    loadRequestQuoteFormConfig().then(function () {
      applyConfiguredContent();
      applyConfiguredControllerOptionsOnce();
      applyConfiguredChoiceOptions();
      applyConfiguredFieldRules();
      updatePrintLocationOptions(false);
      updateModeControllerVisibility();
    });

    var successStyle = document.createElement("style");
    successStyle.setAttribute("data-uqm-success-style", "true");
    successStyle.textContent =
      ".uqm__success-inline{padding:24px!important;border-radius:16px!important;background:#eef8f0!important;border:1px solid #bfe5c9!important;color:#16351f!important;}" +
      ".uqm__success-inline h3{margin:8px 0 8px!important;font-size:22px!important;line-height:1.2!important;color:#10233f!important;}" +
      ".uqm__success-inline p{margin:6px 0!important;}" +
      ".uqm__success-inline .uqm__reference{margin:16px 0;padding:12px 14px;border-radius:12px;background:#fff;border:1px solid #d9e5ef;}" +
      ".uqm__success-inline .uqm__reference span{display:block;font-size:11px;text-transform:uppercase;letter-spacing:.08em;font-weight:800;color:#52647a;}" +
      ".uqm__success-inline .uqm__reference strong{display:block;margin-top:4px;font-size:18px;color:#123b72;}" +
      ".uqm__success-inline .uqm__success-actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:14px;}" +
      ".uqm__success-inline .uqm__success-actions button{min-height:40px;border:0;border-radius:999px;padding:10px 16px;font-weight:800;cursor:pointer;}" +
      "#unisource-quote-modal [aria-invalid='true']{border-color:#b42318!important;background:#fff8f8!important;box-shadow:0 0 0 3px rgba(180,35,24,.10)!important;}" +
      "#unisource-quote-modal .is-invalid legend,#unisource-quote-modal .is-invalid label{color:#b42318!important;}" +
      "#unisource-quote-modal [data-uqm-error]{display:block;color:#b42318!important;font-weight:700!important;}";
    document.head.appendChild(successStyle);

    bindCloseButtons();
    bindForm();
    bindCustomQuoteEvents();
    bindTriggers();
    bindDynamicPromotionalLocations();
    bindDynamicStoleFields();

    document.addEventListener("change", function (event) {
      if (!event.target || event.target.id !== "uqm-pe-package-type") return;
      applyPePackageSelection();
      setError("pePackageType", "");
      setError("peApparel", "");
    });

    window.UnisourceQuoteModal.open = open;
    window.UnisourceQuoteModal.close = close;
    window.UnisourceQuoteModal.parseQuoteUrl = parseQuoteUrl;
    window.UnisourceQuoteModal.setRequestMode = setRequestMode;

    console.info("[Unisource Quote Modal] Installed - Custom Online Store RFQ layout v5");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();